import Dexie from 'dexie'
import DateUtil from './DateUtil'
import api from '../../api'
import emitter from './eventbus.js'
import { default_emoji_data } from './emoji.js'
import axios from 'axios'
import dayjs from 'dayjs'

let md5 = require('js-md5')
const db = new Dexie('flomo')

db.version(2.1).stores({
  memos:
    '++id,&slug,content,tags,links,source,created_at,created_at_long,deleted_at,deleted_at_long,updated_at,updated_at_long,file_ids,files,pin,linked_memos,backlinked_memos',
  tags: '++id,&name,count,icon_type,icon_value,pin,latest_used_at,order',
  links: '++id,source,link',
  files: 'id,name,url,thumbnail_url,parent_slug,index',
  memo_actions: '++id,slug,action_date,action,content,memo_created_at,source,file_ids,fail_count',
  tag_actions: '++id,tag_id,name,rename,icon_type,icon_value,pin,action,created_at',
  memo_content_histories: '++id,slug,hash,updated_at_long',
  tagInfos: 'id,&name,icon_type,icon_value,pin,updated_at,updated_at_long,order',
  zipCache: 'id,file,path',
})

String.prototype.replaceAll = function (FindText, RepText) {
  let regExp = new RegExp(FindText, 'g')
  return this.replace(regExp, RepText)
}

export default class DBUtil {
  static isSyncing = false
  static isOffline = false
  static isInit = false
  static needClean = false

  static tagTotal = 0
  static initTotal = 0
  static initMemos = []
  static initSlugs = []
  static initTagInfos = []
  static initTagMap = {}
  static actionsNeedUpdateAfterSync = []
  static app
  static startSyncTime = 0
  static endSyncTime = 0
  static newMemos = []
  static updateMemoNum = 0
  static isElectron = !!process.env.IS_ELECTRON

  static initI18n(app) {
    DBUtil.app = app
  }

  static sync(isNeedRefresh) {
    if (!DBUtil.isOffline && !DBUtil.isSyncing) {
      DBUtil.isSyncing = true
      DBUtil.pull(isNeedRefresh).then(() => {
        console.log('pull end')
        DBUtil.push()
      })
      this.startSyncTime = Date.now().valueOf()
      emitter.emit('sync-start')
      return true //sync 队列执行
    } else {
      return false //false means sync正在进行中,忽略这次请求
    }
  }

  static pull(isNeedRefresh) {
    return new Promise(async (resolve) => {
      console.log('pull start')
      let last_sync_time = await DBUtil.getLastSyncTime()
      if (!last_sync_time || last_sync_time == 0) {
        last_sync_time = '0'
        DBUtil.isInit = true

        await DBUtil.clearDB()
      } else {
        DBUtil.isInit = false
      }

      let query = db.memos.orderBy('updated_at_long').reverse().first()
      query.then((memo) => {
        DBUtil.pullMemos(
          200,
          last_sync_time,
          memo ? memo.slug : null,
          function async() {
            let last = db.tagInfos.orderBy('updated_at').reverse().first()
            last.then(async () => {
              let tag_last_sync_time = await DBUtil.getTagLastSyncTime()
              DBUtil.pullTags(tag_last_sync_time, last ? last.id : null, 200, () => {
                resolve()
              })
            })
          },
          isNeedRefresh,
        )
      })
    })
  }

  static async checkMemoFiles(action, resolve, callback) {
    let memo = await db.memos.get({ slug: action.slug })
    let waitForUpload = []
    if (!memo) {
      //memo 不存在 删除无效 action  -> 可能错误的指向了 local_ 那条MEMO
      resolve(false)
      db.memo_actions.delete(action.id)
      return
    }

    if (memo.files) {
      for (let file of memo.files) {
        if (!file.url) {
          waitForUpload.push(file)
        }
      }
    }

    //memo本身的files上也有一份 blob对象   file表里也有一份blob对象 实际存了双份,正常发布后,memo上的那份数据会被覆盖掉
    if (waitForUpload && waitForUpload.length > 0) {
      let uploadTasks = []
      for (let localFile of waitForUpload) {
        let promise = new Promise(async (resolve) => {
          DBUtil.uploadFile({ file: localFile.file }, async (result) => {
            if (result) {
              for (let i = 0; i < memo.files.length; i++) {
                let f = memo.files[i]
                if (f.id == localFile.id) {
                  memo.files[i] = result
                  //file表同步更新
                  db.files.delete(localFile.id)
                  result.parent_slug = memo.slug
                  db.files.put(result)
                }
              }
              await db.memos.put(memo)
              resolve(true)
            } else {
              //失败了就跳过这个文件
              console.log('上传失败,跳过这个文件')
              resolve(true)
            }
          })
        })
        uploadTasks.push(promise)
      }

      Promise.all(uploadTasks).then(() => {
        callback()
      })
    } else {
      callback()
    }
  }

  static handlerAction(action) {
    // 排出 action content，避免泄露用户内容
    DBUtil.log(action)
    return new Promise(async (resolve) => {
      if (action.action === 'create') {
        DBUtil.checkMemoFiles(action, resolve, () => {
          DBUtil.doCreateMemoApi(action, resolve)
        }).catch((error) => {
          console.log(error)
        })
      } else if (action.action === 'edit') {
        DBUtil.checkMemoFiles(action, resolve, () => {
          DBUtil.doEditMemoApi(action, resolve)
        }).catch((error) => {
          console.log(error)
        })
      } else if (action.action === 'delete') {
        api.call('DELETE', '/memo/' + action.slug, {}, (response) => {
          try {
            if (response.data && response.data.code === -1) {
              DBUtil.log(response.data)
              //忽略处理
              db.memo_actions.delete(action.id)
              resolve(true)
            } else if (response.data && response.data.code === 0) {
              DBUtil.log(response.data)
              db.memo_actions.delete(action.id)
              DBUtil.notifyActionCountUpdate()
              DBUtil.postUpdateMemoEvent(action.slug)
              resolve(true)
            } else {
              resolve(false)
            }
          } catch (error) {
            console.log(error)
            resolve(false)
          }
        })
      } else if (action.action === 'pin') {
        api.call(
          'POST',
          '/memo/' + action.slug + '/pin',
          {
            force: 1,
          },
          (response) => {
            try {
              if (response.data && response.data.code === -1) {
                DBUtil.log(response.data)
                //使用force模式 忽略错误
                db.memo_actions.delete(action.id)
                resolve(true)
              } else if (response.data && response.data.code === 0) {
                DBUtil.log(response.data)
                db.memo_actions.delete(action.id)
                DBUtil.notifyActionCountUpdate()
                DBUtil.postUpdateMemoEvent(action.slug)
                resolve(true)
              } else {
                resolve(false)
              }
            } catch (error) {
              console.log(error)
              resolve(false)
            }
          },
        )
      } else if (action.action === 'unpin') {
        api.call('POST', '/memo/' + action.slug + '/unpin', {}, (response) => {
          try {
            if (response.data && response.data.code === -1) {
              DBUtil.log(response.data)
              //忽略错误
              db.memo_actions.delete(action.id)
              DBUtil.notifyActionCountUpdate()
              resolve(true)
            } else if (response.data && response.data.code === 0) {
              DBUtil.log(response.data)
              db.memo_actions.delete(action.id)
              DBUtil.notifyActionCountUpdate()
              DBUtil.postUpdateMemoEvent(action.slug)
              resolve(true)
            } else {
              resolve(false)
            }
          } catch (errir) {
            console.log(error)
            resolve(false)
          }
        })
      } else if (action.action === 'restore') {
        api.call('POST', '/memo/' + action.slug + '/restore', {}, async (response) => {
          try {
            if (response.data && response.data.code === -1) {
              DBUtil.log(response.data)
              db.memo_actions.delete(action.id)
              DBUtil.notifyActionCountUpdate()
              DBUtil.postUpdateMemoEvent(action.slug)
              resolve(true)
              //恢复失败 以这条MEMO的数据 重新创建个新MEMO
              let find = await db.memos.get({ slug: action.slug })
              let newMemo = JSON.parse(JSON.stringify(find)) //深拷贝

              newMemo.slug = 'local_' + DateUtil.todayLong + '_' + Math.random()
              delete newMemo.id
              DBUtil.addMemo(newMemo, true)
            } else if (response.data && response.data.code === 0) {
              DBUtil.log(response.data)
              let find = await db.memos.get({ slug: action.slug })
              find.deleted_at_long = 0
              db.memos.put(find)
              db.memo_actions.delete(action.id)
              DBUtil.notifyActionCountUpdate()
              DBUtil.postUpdateMemoEvent(action.slug)
              resolve(true)
            } else {
              resolve(false)
            }
          } catch (error) {
            console.log(error)
            resolve(false)
          }
        })
      }
    })
  }

  static async postUpdateMemoEvent(slug) {
    let memo = await db.memos.get({ slug: slug })
    if (memo) {
      await DBUtil.prepareMemoLinks(memo)
      await DBUtil.applyTags(memo)
      await DBUtil.prepareFiles(memo)
      memo.is_show_cloud = false //删除action是异步的,有可能还没删除成功,这里不查询了.
      emitter.emit('memo-updated', memo)
    }
  }

  static checkFileUpload(action) {
    return new Promise((resolve) => {
      if (action.action === 'create' && action.file_ids && action.file_ids.length > 0) {
        let file_ids = action.file_ids
        let file_id_list = []
        for (let i = 0; i < file_ids.length; i++) {
          file_id_list.push(file_ids[i].file_id)
        }
        let query = db.files.where('file_id').anyOf(file_id_list)
        query.toArray().then((files) => {
          if (files.length > 0) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      } else {
        resolve(false)
      }
    })
  }

  static async doCreateMemoApi(action, resolve) {
    try {
      let fake_slug = action.slug
      let memo = await db.memos.get({ slug: action.slug })
      if (!memo) {
        resolve(false)
        return
      }
      let file_ids = []
      if (action.file_ids) {
        for (let id of action.file_ids) {
          if (!DBUtil.isLocal(id) && id) {
            file_ids.push(id)
          }
        }
      }
      //已上传的file_ids
      if (memo.file_ids) {
        for (let id of memo.file_ids) {
          if (!DBUtil.isLocal(id) && id) {
            file_ids.push(id)
          }
        }
      }
      //将file对象上的id也加进file_ids
      if (memo.files) {
        for (let file of memo.files) {
          if (!DBUtil.isLocal(file.id) && file.id) {
            file_ids.push(file.id)
          }
        }
      }
      //去重
      file_ids = Array.from(new Set(file_ids))

      api.call(
        'PUT',
        '/memo',
        {
          content: action.content,
          created_at: action.action_date,
          source: action.source,
          file_ids: file_ids,
          tz: DateUtil.getTz(),
        },
        async (response) => {
          try {
            if (response.data && response.data.code === -1) {
              DBUtil.log(response.data)
              action.fail_count = action.fail_count ? action.fail_count + 1 : 1
              if (action.fail_count >= 5) {
                db.memo_actions.delete(action.id)
              } else {
                db.memo_actions.put(action)
              }
              resolve(false)
            } else if (response.data && response.data.code === 0) {
              DBUtil.log(response.data)
              db.memo_actions.delete(action.id)
              DBUtil.notifyActionCountUpdate()
              let memo = await db.memos.get({ slug: action.slug })
              if (memo) {
                memo.slug = response.data.data.slug
                memo.files = response.data.data.files
                memo.pin = response.data.data.pin ? response.data.data.pin : 0
                db.memos.put(memo)
                memo.fake_slug = action.slug
                db.memo_content_histories.put({
                  slug: memo.slug,
                  hash: DBUtil.hashCode(memo.content),
                  updated_at: memo.updated_at,
                })

                //更新link source
                let links = await db.links.where('source').equals(action.slug).toArray()
                for (let link of links) {
                  link.source = memo.slug
                }
                await db.links.bulkPut(links)

                //更新Files
                let files = await db.files.where('parent_slug').equals(fake_slug).toArray()
                for (let file of files) {
                  file.parent_slug = memo.slug
                }
                await db.files.bulkPut(files)

                memo.is_show_cloud = false //删除action是异步的,有可能还没删除成功,这里不查询了.
                // 同步完成从 newMemos 中删除已经同步的 memo
                DBUtil.newMemos = DBUtil.newMemos.filter((m) => m.fake_slug != memo.fake_slug)
                emitter.emit('memo-updated', memo)
                const { linked_memos } = response.data.data

                DBUtil.handle_linked_memos(linked_memos)
              }
              resolve(true)
            } else {
              action.fail_count = action.fail_count ? action.fail_count + 1 : 1
              db.memo_actions.put(action)
              resolve(false)
            }
          } catch (error) {
            console.log(error)
            resolve(false)
          }
        },
      )
    } catch (error) {
      console.log(error)
      resolve(false)
    }
  }

  static doEditMemoApi(action, resolve) {
    db.memos.get({ slug: action.slug }).then((memo) => {
      let file_ids = []
      if (action.file_ids) {
        for (let id of action.file_ids) {
          if (!DBUtil.isLocal(id)) {
            file_ids.push(id)
          }
        }
      }
      //已上传的file_ids
      if (memo.file_ids) {
        for (let id of memo.file_ids) {
          if (!DBUtil.isLocal(id)) {
            file_ids.push(id)
          }
        }
      }
      //将file对象上的id也加进file_ids
      if (memo.files) {
        for (let file of memo.files) {
          if (!DBUtil.isLocal(file.id)) {
            file_ids.push(file.id)
          }
        }
      }
      //去重
      file_ids = Array.from(new Set(file_ids))
      api.call(
        'PUT',
        '/memo/' + action.slug,
        {
          content: action.content,
          created_at: action.memo_created_at,
          local_updated_at: action.action_date,
          source: action.source,
          file_ids: file_ids,
          tz: DateUtil.getTz(),
          pin: action.pin,
        },
        async (response) => {
          if (response.data && response.data.code === -1) {
            DBUtil.log(response.data)
            //非法修改 比如 content 和 images都为空
            action.fail_count = action.fail_count ? action.fail_count + 1 : 1
            if (action.fail_count >= 5) {
              db.memo_actions.delete(action.id)
            } else {
              db.memo_actions.put(action)
            }
            resolve(false)
          } else if (response.data && response.data.code === -20) {
            DBUtil.log(response.data)
            //服务端冲突
            //不处理 它应当会在下次同步时,转化为客户端冲突
            action.fail_count = action.fail_count ? action.fail_count + 1 : 1

            if (action.fail_count >= 5) {
              db.memo_actions.delete(action.id)
            } else if (action.fail_count >= 1) {
              action.action_date = DateUtil.todayLong() + action.fail_count * 30 //发生一次错误 修正补偿30秒
              db.memo_actions.put(action)
            } else {
              db.memo_actions.put(action)
            }

            resolve(true)
          } else if (response.data && response.data.code === 0) {
            DBUtil.log(response.data)
            let oldFiles = memo.files
            memo.files = response.data.data.files
            memo.pin = response.data.data.pin
            db.memo_content_histories.put({
              slug: memo.slug,
              hash: DBUtil.hashCode(memo.content),
              updated_at: memo.updated_at,
            })

            memo.is_show_cloud = false

            // fix bug: 编辑memo 不显示关联的memo数量
            memo.backlinked_memos = response.data.data.backlinked_memos
            memo.linked_memos = response.data.data.linked_memos

            let index = 0
            let fileForInsert = []
            for (let file of memo.files) {
              file.parent_slug = memo.slug
              file.index = index
              fileForInsert.push(file)
              index++
            }
            if (fileForInsert.length > 0) db.files.bulkPut(fileForInsert)

            //如果新的files数组和老的files数组一样,且老的files对象没有过期,那么event返回老的files数组,否则文件签名变化了,浏览器会重新拉取图片,导致页面闪烁
            // if (oldFiles && memo.files && oldFiles.length == memo.files.length) {
            //     let expireFils = oldFiles.filter((item) => { return DBUtil.isFileExpire(item) && item.url.indexOf("temp") < 0 }); //如果是临时文件,也需要刷新
            //     let isArrEqual = true;
            //     if (expireFils.length == 0) {
            //         for (let i = 0; i < oldFiles.length; i++) {
            //             if (oldFiles[i].id != memo.files[i].id) {
            //                 isArrEqual = false;
            //                 break;
            //             }
            //         }
            //         if (isArrEqual) {
            //             memo.files = oldFiles;
            //         }
            //     }
            // }

            db.memos.put(memo)
            db.memo_actions.delete(action.id)
            DBUtil.notifyActionCountUpdate()
            emitter.emit('memo-updated', memo)

            DBUtil.handle_linked_memos([...memo.backlinked_memos, ...memo.linked_memos])
            resolve(true)
          } else {
            //其它错误
            action.fail_count = action.fail_count ? action.fail_count + 1 : 1
            db.memo_actions.put(action)
            resolve(false)
          }
        },
      )
    })
  }

  static handlerTagAction(action) {
    return new Promise(async (resolve) => {
      if (action.action === 'pin') {
        api.call(
          'POST',
          '/tag/pin',
          {
            tag: action.name,
            tz: DateUtil.getTz(),
          },
          async (response) => {
            try {
              if (response.data && response.data.code === -1) {
                DBUtil.log(response.data)
                //使用force模式 忽略错误
                db.tag_actions.delete(action.id)
                DBUtil.notifyActionCountUpdate()
                resolve(true)
              } else if (response.data && response.data.code === 0) {
                DBUtil.log(response.data)
                let info = response.data.data
                //如果原本操作的是个本地tag,那么它taginfo id是本地生成
                let local = await db.tagInfos.get({ name: info.name })
                if (local && local.id >= Number.MAX_VALUE / 2) {
                  await db.tagInfos.delete(local.id)
                }

                db.tagInfos.put(info)
                db.tag_actions.delete(action.id)
                DBUtil.notifyActionCountUpdate()

                //do nothing
                resolve(true)
              } else {
                resolve(false)
              }
            } catch (error) {
              console.log(error)
              resolve(false)
            }
          },
        )
      } else if (action.action === 'unpin') {
        api.call(
          'POST',
          '/tag/unpin',
          {
            tag: action.name,
            tz: DateUtil.getTz(),
          },
          (response) => {
            try {
              if (response.data && response.data.code === -1) {
                DBUtil.log(response.data)
                //忽略错误
                db.tag_actions.delete(action.id)
                resolve(true)
              } else if (response.data && response.data.code === 0) {
                DBUtil.log(response.data)
                db.tag_actions.delete(action.id)
                //do nothing
                resolve(true)
              } else {
                resolve(false)
              }
              DBUtil.notifyActionCountUpdate()
            } catch (error) {
              console.log(error)
              resolve(false)
            }
          },
        )
      } else if (action.action === 'change_icon') {
        api.call(
          'POST',
          '/tag/icon',
          {
            tag: action.name,
            icon_type: action.icon_type,
            icon_value: action.icon_value,
            tz: DateUtil.getTz(),
          },
          (response) => {
            try {
              if (response.data && response.data.code === -1) {
                DBUtil.log(response.data)
                db.tag_actions.delete(action.id)
                DBUtil.notifyActionCountUpdate()
                resolve(true)
              } else if (response.data && response.data.code === 0) {
                DBUtil.log(response.data)
                let info = response.data.data
                //如果是个本地Tag,直接删了原来的
                if (action.tag_id >= Number.MAX_VALUE / 2) {
                  db.tagInfos.delete(action.tag_id)
                }
                db.tagInfos.put(info)
                db.tag_actions.delete(action.id)
                DBUtil.notifyActionCountUpdate()
                //do nothing
                resolve(true)
              } else {
                resolve(false)
              }
            } catch (error) {
              console.log(error)
              resolve(false)
            }
          },
        )
      } else if (action.action === 'rename') {
        try {
          if (DBUtil.isLocal(action.tag_id)) {
            let tagInfo = await db.tagInfos.get({ name: action.name })
            if (!tagInfo) {
              tagInfo = await db.tagInfos.get({ name: action.rename })
            }

            if (!tagInfo) {
              db.tag_actions.delete(action.id)
              DBUtil.notifyActionCountUpdate()
              resolve(true)
              return
            }
            action.tag_id = tagInfo.id
          }
        } catch (error) {
          console.log(error)
          resolve(false)
          return
        }

        const tag_id = action.tag_id ? action.tag_id : ''
        const old_tag_name = action.name ? action.name : ''

        api.call(
          'PUT',
          '/tag/' + tag_id,
          {
            name: action.rename,
            tz: DateUtil.getTz(),
            order: action.order ? action.order : 0,
            old_tag_name,
          },
          async (response) => {
            try {
              if (response.data && response.data.code === -1) {
                DBUtil.log(response.data)
                //忽略错误
                db.tag_actions.delete(action.id)
                DBUtil.notifyActionCountUpdate()
                resolve(true)
              } else if (response.data && response.data.code === 0) {
                DBUtil.log(response.data)
                let info = response.data.data
                //如果是个本地Tag,直接删了原来的
                if (action.tag_id >= Number.MAX_VALUE / 2) {
                  db.tagInfos.delete(info.id)
                }
                // 如果已经存在的话，就不要再插入了
                let local = await db.tagInfos.get({ name: info.name })
                if (!local) {
                  db.tagInfos.put(info)
                }

                db.tag_actions.delete(action.id)
                DBUtil.notifyActionCountUpdate()
                //do nothing
                resolve(true)
              } else {
                resolve(false)
              }
            } catch (error) {
              console.log(error)
              resolve(false)
            }
          },
        )
      }
    })
  }

  static async push() {
    console.log('push start')
    let memoActions = await db.memo_actions.toArray()
    let tagActions = await db.tag_actions.toArray()

    const sort_index = ['create', 'edit', 'restore', 'pin', 'unpin', 'delete']
    //sort memo actions
    memoActions.sort((a, b) => {
      let s1 = sort_index.indexOf(a.action)
      let s2 = sort_index.indexOf(b.action)

      if (s1 > s2) {
        return 1
      } else if (s1 == s2) return 0
      else return -1
    })

    console.log('push memo actions', memoActions.length)
    for (let i = 0; i < memoActions.length; i++) {
      // 排出 memoAction content，避免泄露用户内容
      DBUtil.log(memoActions[i])
      //最终兜底,如果有个action始终没有被处理,则把它删掉
      if (memoActions[i].fail_coun >= 5) {
        db.memo_actions.delete(memoActions[i].id)
      } else {
        let start = new Date().getTime()
        let result = await DBUtil.handlerAction(memoActions[i])
        if (!result) {
          //失败了 action fail_count + 1
          let action = await db.memo_actions.get({ id: memoActions[i].id })
          if (action) {
            action.fail_count = action.fail_count + 1
            db.memo_actions.put(action)
          }
        }
        let end = new Date().getTime()
        if (end - start < 500) {
          let out = await DBUtil.sleep(500 - (end - start))
        }
      }
    }

    console.log('push memo actions end')
    console.log('push tag actions', tagActions.length)
    for (let i = 0; i < tagActions.length; i++) {
      let start = new Date().getTime()
      let result = await DBUtil.handlerTagAction(tagActions[i])
      if (!result) {
        //失败了 action fail_count + 1
        let action = await db.memo_actions.get({ id: tagActions[i].id })
        if (action) {
          action.fail_count = action.fail_count + 1
          db.tag_actions.put(action)
        }
      }
      let end = new Date().getTime()
      if (end - start < 500) {
        let out = await DBUtil.sleep(500 - (end - start))
      }
    }

    console.log('push tag actions end')
    this.endSyncTime = new Date().valueOf()
    console.log('sync done, cost time:', this.endSyncTime - this.startSyncTime, 'ms')
    DBUtil.isInit = false
    emitter.emit('sync-finish', { count_down: 0 })

    for (let action of DBUtil.actionsNeedUpdateAfterSync) {
      //确认下这条action是否还存在，如果存在则更新action_date
      let find = await db.memo_actions.get({ id: action.id })
      if (find) {
        action.action_date = DateUtil.todayLong()
        db.memo_actions.put(action)
        console.log('更新action:', {
          ...action,
          content: '******',
        })
      }
    }
    //清空数组
    DBUtil.actionsNeedUpdateAfterSync = []

    if (DBUtil.needClean) {
      DBUtil.cleanDB()
    }

    setTimeout(() => {
      DBUtil.initSlugs = []
    }, 2000)

    DBUtil.isSyncing = false
  }

  static pullMemos(limit, latest_updated_at, latest_slug, callback, isNeedRefresh) {
    let start = +new Date()
    console.log('pull memos:' + latest_updated_at)
    api.call(
      'GET',
      '/memo/updated/',
      {
        limit: limit,
        latest_updated_at: latest_updated_at,
        latest_slug: latest_slug,
        tz: DateUtil.getTz(),
      },
      async (response) => {
        if (response.data && response.data.code === 0) {
          console.log('pull memos:' + latest_updated_at + ':success')
          let memos = response.data.data
          DBUtil.updateMemoNum += memos.length
          let count = 0
          let waitForInsert = []
          let fileForInsert = []
          for (let element of memos) {
            try {
              let find = DBUtil.isInit ? false : await db.memos.get({ slug: element.slug })
              if (!find) {
                element.created_at_long = DateUtil.formatDateStringToSeconds(element.created_at)
                if (element.deleted_at) element.deleted_at_long = DateUtil.formatDateStringToSeconds(element.deleted_at)
                else element.deleted_at_long = 0
                element.updated_at_long = DateUtil.formatDateStringToSeconds(element.updated_at)

                DBUtil.saveLinks(element, true)
                await DBUtil.updateTag(element, true)
                if (DBUtil.isInit) {
                  let index = 0

                  if (DBUtil.initSlugs.indexOf(element.slug) == -1) {
                    waitForInsert.push(element)
                    DBUtil.initMemos.push(element)
                    DBUtil.initSlugs.push(element.slug)

                    for (let file of element.files) {
                      file.parent_slug = element.slug
                      file.index = index
                      fileForInsert.push(file)
                      index++
                    }
                  } else {
                    console.log('忽略init 进程中的 重复memo', {
                      ...element,
                      content: '******',
                    })
                  }
                } else {
                  db.memos.put(element)
                }
              } else {
                element.id = find.id
                element.created_at_long = DateUtil.formatDateStringToSeconds(element.created_at)

                if (element.deleted_at) element.deleted_at_long = DateUtil.formatDateStringToSeconds(element.deleted_at)
                else element.deleted_at_long = 0

                element.updated_at_long = DateUtil.formatDateStringToSeconds(element.updated_at)
                //CONFLICT CHECK

                let actions = await db.memo_actions.where('slug').equals(element.slug).toArray()

                //冲突
                if (actions && actions.length > 0) {
                  console.log('CONFLICT')
                  let action_str_array = []
                  let isLocalNewer = false

                  for (let i = 0; i < actions.length; i++) {
                    let action = actions[i]
                    action_str_array.push(action.action)
                    //因为updated_at用于last_sync_time表示,所以本地操作不再更新memo.updated_at,此处使用action.action_date作为本地修改操作的时间
                    let action_date_long = action.action_date
                    //如果本地任意一个操作的时间 比 server端的 updated_at要大,说明本地的版本更新
                    if (action_date_long >= element.updated_at_long) isLocalNewer = true
                  }

                  if (action_str_array.includes('edit')) {
                    let memo_hash_histories = await db.memo_content_histories
                      .where('slug')
                      .equals(element.slug)
                      .toArray()

                    //check一下 2个文本是否一致  如果文本不一致 执行冲突流程
                    if (find.content == element.content) {
                      //文本一致 files 以教新的为准 -> 真的发生files冲突时，会丢失较老的图片
                      let localFiles = find.files
                      let serverFiles = element.files

                      element.files = isLocalNewer ? localFiles : serverFiles
                      //忽略冲突时更新action_date https://www.mubucm.com/doc/3tAa6sBHW0p
                      console.log('更新action_date')
                      for (let action of actions) {
                        action.action_date = element.updated_at_long + 1
                        db.memo_actions.put(action)
                      }
                    } else {
                      /*
                        * search slug + hash(memo.content) 在 MEMO HISTORY中是否存在.
                        如果存在记录. 则认为此content是本地的,忽略冲突.并且 [不]  更新本地Memo
                        如果不存在 走现在冲突逻辑 生成副本.
                        副本实际创建成功时,由副本的实际slug创建新的MEMO HISTORY记录,和原MEMO无关联.也不继承原MEMO的HISTORY
                      * */
                      if (memo_hash_histories) {
                        let hash_array = []
                        for (let i = 0; i < memo_hash_histories.length; i++) {
                          hash_array.push(memo_hash_histories[i].hash)
                        }

                        if (hash_array.includes(DBUtil.hashCode(element.content))) {
                          //本地历史版本 忽略此次pull中content数据
                          element.content = find.content
                          //忽略冲突时需要更新action_date https://www.mubucm.com/doc/3tAa6sBHW0p
                          console.log('更新action_date')
                          for (let action of actions) {
                            action.action_date = element.updated_at_long + 1
                            db.memo_actions.put(action)
                          }
                        } else {
                          //生成一个新的MEMO
                          let newMemo = JSON.parse(JSON.stringify(find)) //深拷贝

                          newMemo.slug = 'local_' + DateUtil.todayLong + '_' + Math.random()
                          delete newMemo.id

                          let conflict_header = DBUtil.app.$t('components.Memo.conflict_header')
                          newMemo.content = conflict_header + find.content
                          //原本的action都删了
                          await db.memo_actions.bulkDelete(actions.map((item) => item.id))

                          DBUtil.addMemo(newMemo, true)
                        }
                      }
                    }
                  } else if (action_str_array.includes('delete')) {
                    element.deleted_at_long = isLocalNewer ? find.getDeleted_at_long : element.deleted_at_long
                    element.deleted_at = isLocalNewer ? find.getDeleted_at : element.deleted_at

                    //忽略冲突时需要更新action_date https://www.mubucm.com/doc/3tAa6sBHW0p
                    console.log('更新action_date')
                    for (let action of actions) {
                      action.action_date = element.updated_at_long + 1
                      db.memo_actions.put(action)
                    }
                  } else if (action_str_array.includes('pin') || action_str_array.includes('unpin')) {
                    element.pin = isLocalNewer ? find.pin : element.pin

                    //忽略冲突时需要更新action_date https://www.mubucm.com/doc/3tAa6sBHW0p
                    console.log('更新action_date')
                    for (let action of actions) {
                      action.action_date = element.updated_at_long + 1
                      db.memo_actions.put(action)
                    }
                  }
                  await DBUtil.saveLinks(element)
                  await DBUtil.updateTag(element)
                  await DBUtil.saveFiles(element)
                  await DBUtil.isShowCloud(element)
                  db.memos.put(element)

                  if (!DBUtil.isInit) emitter.emit('memo-updated', element)
                } else {
                  await DBUtil.saveLinks(element)
                  await DBUtil.updateTag(element)
                  await DBUtil.saveFiles(element)
                  await DBUtil.isShowCloud(element)
                  await db.memos.put(element)
                  if (!DBUtil.isInit) emitter.emit('memo-updated', element)
                }
              }
            } catch (error) {
              //单条MEMO数据pull处理失败 TODO 记录日志
              console.log(error)
            }
          }
          if (waitForInsert.length > 0) {
            try {
              console.time('bulk add memo')
              await db.memos.bulkAdd(waitForInsert)
              console.timeEnd('bulk add memo')
            } catch (error) {
              console.error('bulk add', error)
            }
          }
          if (fileForInsert.length > 0) {
            console.time('bulk add memo')
            await db.files.bulkAdd(fileForInsert)
            console.timeEnd('bulk add memo')
          }

          if (isNeedRefresh) {
            if (memos.length > 0) emitter.emit('memo-list-updated')
          }
          if (memos.length < limit) {
            //穷尽结束

            if (DBUtil.isInit) {
              let tagArr = []
              let tagIndex = 0
              for (let key in DBUtil.initTagMap) {
                tagArr.push({
                  name: key,
                  count: DBUtil.initTagMap[key],
                  latest_used_at: tagIndex,
                })
                tagIndex++
              }
              DBUtil.filterTag(tagArr)

              try {
                console.time('bulk add tags')
                await db.tags.bulkAdd(tagArr)
                console.timeEnd('bulk add tags')
              } catch (error) {
                console.error('bulk add tags', error)
              }
            }
            callback()
            let end = +new Date()
            DBUtil.initTotal += end - start
          } else {
            let end = +new Date()
            if (end - start < 800) {
              await DBUtil.sleep(800 - (end - start))
            }

            //继续
            let latest_updated_at = DateUtil.formatDateStringToSeconds(memos[memos.length - 1].updated_at)
            let latest_slug = memos[memos.length - 1].slug
            this.pullMemos(limit, latest_updated_at, latest_slug, callback, isNeedRefresh)

            end = +new Date()
            DBUtil.initTotal += end - start
          }
        } else {
          //PULL 失败了 直接结束整个SYNC流程 不更新 last_sync_time
          DBUtil.isInit = false
          DBUtil.initSlugs = []
          DBUtil.isSyncing = false
          emitter.emit('sync-finish')
        }
      },
    )
  }

  static pullTags(latest_updated_at, latest_id, limit, callback) {
    console.log('pull Tags:' + latest_updated_at)
    api.call(
      'GET',
      '/tag/updated/',
      {
        limit: limit,
        latest_updated_at: latest_updated_at,
        latest_id: latest_id,
        tz: DateUtil.getTz(),
      },
      async (response) => {
        if (response.data && response.data.code === -1) {
          callback()
        } else if (response.data && response.data.code === 0) {
          console.log('pull Tags:' + latest_updated_at + ':success')
          DBUtil.log(response.data)

          let tagInfos = response.data.data
          if (tagInfos != null && tagInfos.length > 0) {
            for (let element of tagInfos) {
              try {
                DBUtil.initTagInfos.push(element)
                let tagInfo = await db.tagInfos.get({ id: element.id })
                let tagInfoNameQuery = await db.tagInfos.get({ name: element.name })

                //如果有同名tagInfos,那用新的那条覆盖老的
                if (tagInfoNameQuery && element.id != tagInfoNameQuery.id) {
                  await db.tagInfos.delete(tagInfoNameQuery.id)
                }

                if (!tagInfo) {
                  db.tagInfos.put(element)
                } else {
                  //conflict处理 tag conflict时，本地如果有修改，那总是以本地覆盖云端
                  let action = await db.tag_actions.get({ name: element.name })
                  if (action) {
                    // 本地有任何操作 总是视为本地更新 此时不做更新
                    // db.tagInfos.put(element)
                  } else {
                    db.tagInfos.put(element)
                  }
                }
              } catch (error) {
                console.log(error)
                //单条Tag处理失败
              }
            }

            if (tagInfos.length < limit) {
              callback()
            } else {
              let last = tagInfos[tagInfos.length - 1]
              let updated_at_long = DateUtil.formatDateStringToSeconds(last.updated_at)
              DBUtil.pullTags(updated_at_long, last.id, limit, callback)
            }
          } else {
            callback()
          }
        }
      },
    )
  }

  //主LIST
  static getMemos(
    offset,
    limit,
    tag,
    search,
    start_date,
    end_date,
    source,
    with_image,
    with_tag,
    with_link,
    contain_tag,
    last_year_today,
    deny_tag,
  ) {
    console.log(
      'getMemos',
      offset,
      limit,
      tag,
      search,
      start_date,
      end_date,
      source,
      with_image,
      with_tag,
      with_link,
      contain_tag,
      last_year_today,
      deny_tag,
    )

    if (DBUtil.isInit) {
      //初始化过程中 搜索getMemos在内存中执行
      return new Promise((resolve) => {
        let memos = DBUtil.initMemos
        memos.sort(function (a, b) {
          return b.created_at_long - a.created_at_long
        })

        memos = memos.filter(function (item) {
          return !item.deleted_at
        })

        let result = memos.slice(offset, offset + limit)
        resolve({
          total: memos.length,
          memos: result,
        })
      })
    } else {
      // 判断是不是搜索,如果不是搜索查询就不需要查询 count
      let isSearch = false
      if (
        !tag &&
        !search &&
        !start_date &&
        !end_date &&
        !source &&
        !with_image &&
        with_tag == undefined &&
        !with_link &&
        !contain_tag &&
        !last_year_today &&
        !deny_tag
      ) {
        isSearch = false
      } else {
        isSearch = true
      }
      let startTime = Date.now().valueOf()
      return new Promise(async (resolve) => {
        let query = db.memos.orderBy('created_at_long')
        if (isSearch) {
          if (start_date != null && end_date != null) {
            start_date = start_date + ' 00:00:00'
            end_date = end_date + ' 23:59:59'
            //query = query.where('created_at').between(start_date, end_date)
            query = query.filter(function (item) {
              let item_created_at = item.created_at
              let item_created_at_long = DateUtil.formatDateStringToSeconds(item_created_at)
              let start_date_long = DateUtil.formatDateStringToSeconds(start_date)
              let end_date_long = DateUtil.formatDateStringToSeconds(end_date)
              return item_created_at_long >= start_date_long && item_created_at_long <= end_date_long
            })
          }
          if (last_year_today != null) {
            // 获取年今天的日期
            let last_year_today_date = new Date()
            last_year_today_date.setFullYear(last_year_today_date.getFullYear() - 1)
            last_year_today_date = DateUtil.formatDateStringToDateOnly(last_year_today_date)

            let userCreatedDate = DateUtil.formatDateStringToDateOnly(this.getUserCreatedAt())
            let last_year_today_start = userCreatedDate + ' 00:00:00'
            let last_year_today_end = last_year_today_date + ' 23:59:59'
            //query = query.where('created_at').between(last_year_today_start, last_year_today_end)
            query = query.filter(function (item) {
              let item_created_at = item.created_at
              let item_created_at_long = DateUtil.formatDateStringToSeconds(item_created_at)
              let last_year_today_start_long = DateUtil.formatDateStringToSeconds(last_year_today_start)
              let last_year_today_end_long = DateUtil.formatDateStringToSeconds(last_year_today_end)
              return (
                item_created_at_long >= last_year_today_start_long && item_created_at_long <= last_year_today_end_long
              )
            })
          }
          if (source != null) {
            //query = query.where('source').equals(source)
            query = query.filter(function (item) {
              return item.source == source
            })
          }
        }

        query = query.filter(function (item) {
          let result_search = true
          let result_tag = true
          if (search != null) {
            let searchArr = []
            if (search.includes(' ')) {
              let arr = search.split(' ')
              for (let item of arr) {
                if (item != ' ' && item.length > 0) searchArr.push(item)
              }
            } else {
              searchArr.push(search)
            }
            if (item.content) {
              for (let keyword of searchArr) {
                // 过滤 content 中的 html 标签，只匹配纯文本
                let content = item.content.replace(/<[^>]+>/g, '')
                result_search = content.toLowerCase().includes(keyword.toLowerCase())
                if (!result_search) {
                  result_search = false
                  break
                }
              }
            } else result_search = false
          }
          if (tag) {
            result_tag = item.tags.includes(tag)
          }

          // 匹配标签名以/开头的标签
          if (tag == '') {
            result_tag = item.tags.some((item) => {
              return item.startsWith('/')
            })
          }

          if (deny_tag) {
            result_tag = !item.tags || !item.tags.includes(deny_tag)
          }

          let result_image_filter = true
          if (typeof with_image == 'undefined') {
            result_image_filter = true
          } else if (with_image) {
            result_image_filter = item.files != null && item.files.length > 0
          } else {
            result_image_filter = item.files == null || item.files.length == 0
          }

          let result_tag_filter = true
          if (typeof with_tag == 'undefined') {
            result_tag_filter = true
          } else if (with_tag) {
            result_tag_filter = item.tags != null && item.tags.length > 0
          } else {
            result_tag_filter = item.tags == null || item.tags.length == 0
          }

          let result_link_filter = true
          if (typeof with_link == 'undefined') {
            result_link_filter = true
          } else if (with_link) {
            result_link_filter = item.links != null && item.links.length > 0
          } else {
            result_link_filter = item.links == null || item.links.length == 0
          }

          let result_contain_tag = true
          if (typeof contain_tag == 'undefined') {
            result_contain_tag = true
          } else if (contain_tag) {
            result_contain_tag = item.tags != null && item.tags.length > 0 && item.tags.includes(tag)
          } else {
            result_contain_tag = item.tags != null && item.tags.length > 0 && !item.tags.includes(tag)
          }

          let result_contain_some_date = true
          if (last_year_today != null) {
            const item_created_at_date = item.created_at.split(' ')[0]
            const [item_month, item_day] = item_created_at_date.split('-').slice(1)
            const today = dayjs()
            const today_month = today.format('MM')
            const today_day = today.format('DD')
            result_contain_some_date = item_month === today_month && item_day === today_day
          }

          return (
            result_search &&
            result_tag &&
            item.deleted_at_long == 0 &&
            result_image_filter &&
            result_tag_filter &&
            result_link_filter &&
            result_contain_tag &&
            result_contain_some_date
          )
        })

        const result = await db.transaction('rw', db.memos, async () => {
          const totalCountPromise = isSearch ? query.count() : Promise.resolve(null)
          const [totalCount, memos] = await Promise.all([
            totalCountPromise,
            query.reverse().offset(offset).limit(limit).toArray(),
          ])

          return { totalCount, memos }
        })

        const { totalCount, memos } = result
        let endTime = Date.now().valueOf()
        let time = endTime - startTime
        console.log('getMemos cost time：' + time + 'ms,', 'offset', offset, 'Total Count:', totalCount)
        let waitForCheck = []

        for (let item of memos) {
          await DBUtil.prepareMemoLinks(item)
          await DBUtil.applyTags(item)
          await DBUtil.prepareFiles(item)
          await DBUtil.isShowCloud(item)
          DBUtil.reformatDate(item)

          if (item.files) waitForCheck = waitForCheck.concat(item.files)
        }

        let refreshFiles = await DBUtil.checkImageUrl(waitForCheck)
        let memosNeedRefresh = []
        if (refreshFiles && refreshFiles.length > 0) {
          for (let item of memos) {
            if (item.files) {
              for (let i = 0; i < item.files.length; i++) {
                let file = item.files[i]
                let needRefresh = false
                for (let refreshFile of refreshFiles) {
                  if (refreshFile.id == file.id) {
                    item.files.splice(i, 1, refreshFile)
                    needRefresh = true
                  }
                }
                if (needRefresh) memosNeedRefresh.push(item)
              }
            }
          }
        }

        resolve({
          total: totalCount,
          memos: memos,
        })

        //更新到数据库
        if (refreshFiles && refreshFiles.length > 0) {
          //更新file表
          db.files.bulkPut(refreshFiles)
          db.memos.bulkPut(memosNeedRefresh)
        }
      })
    }
  }

  static async getMemo(slug, withDeepLinks) {
    try {
      let find = await db.memos.get({ slug: slug })

      if (find) {
        await Promise.all([
          DBUtil.prepareMemoLinks(find),
          DBUtil.applyTags(find),
          DBUtil.prepareFiles(find),
          DBUtil.isShowCloud(find),
        ])

        DBUtil.reformatDate(find)

        if (withDeepLinks) {
          const linkedMemos = find.linked_memos || []
          const backlinkedMemos = find.backlinked_memos || []

          await Promise.all([
            ...linkedMemos.map((memo) => DBUtil.prepareMemoLinks(memo)),
            ...backlinkedMemos.map((memo) => DBUtil.prepareMemoLinks(memo)),
          ])
        }

        find = await DBUtil.refreshMemoFiles(find)
      }

      return find
    } catch (error) {
      console.error('Error in getMemo:', error)
      return null
    }
  }

  static addMemo(memo, ignoreSync) {
    return new Promise(async (resolve) => {
      try {
        if (!memo.slug) {
          let fake_slug = 'local_' + DateUtil.todayLong()
          memo.fake_slug = fake_slug
          memo.slug = fake_slug
        }
        if (!memo.created_at) {
          memo.created_at = DateUtil.today()
          memo.created_at_long = DateUtil.todayLong()
        }
        // memo.updated_at = memo.created_at
        // memo.updated_at_long = memo.created_at_long

        memo.deleted_at = null
        memo.deleted_at_long = 0

        memo.source = 'web'
        memo.pin = 0

        let promises = []
        promises.push(DBUtil.saveLinks(memo))
        promises.push(DBUtil.updateTag(memo))
        promises.push(DBUtil.saveFiles(memo))
        Promise.all(promises)
          .then(() => {
            let p1 = db.memos.put(memo)
            let action = {
              action: 'create',
              slug: memo.slug,
              content: memo.content,
              file_ids: memo.file_ids,
              memo_created_at: memo.created_at_long,
              action_date: DateUtil.todayLong(),
              source: 'web',
            }
            let p2 = db.memo_actions.put(action)

            Promise.all([p1, p2])
              .then(() => {
                DBUtil.notifyActionCountUpdate()
                if (!ignoreSync) {
                  DBUtil.sync()
                }
                // 离线显示待同步
                memo.is_show_cloud = DBUtil.isOffline ? true : false
                DBUtil.newMemos.push(memo)
                // 3s 检查是否同步完成
                setTimeout(DBUtil.checkMemoSyncComplete, 3000)

                resolve(memo)
              })
              .catch((error) => {
                resolve(error)
              })
          })
          .catch((error) => {
            resolve(error)
          })
      } catch (error) {
        resolve(error)
        return
      }
    })
  }

  static async notifyActionCountUpdate() {
    let count = await this.getTotalActionCount()
    emitter.emit('action-count-updated', count)
  }

  static editMemo(target, ignoreSync) {
    DBUtil.log(target)
    return new Promise((resolve) => {
      let find = db.memos.get({ slug: target.slug })
      find.then(async (memo) => {
        if (!memo) {
          let error = new Error('memo not found')
          error.name = 'MemoNotFound'
          resolve(error)
          return
        }
        memo.content = target.content
        memo.file_ids = target.file_ids ? target.file_ids : []
        memo.pin = target.pin

        let waitForRemove = []
        if (memo.files) {
          for (let file of memo.files) {
            //如果不是local_file && file.id 又不在传入的数组中,说明被删除了
            if (!DBUtil.isLocal(file.id) && file.id != 0) {
              if (target.file_ids && !target.file_ids.includes(file.id)) {
                waitForRemove.push(file)
              }
            }
          }
        }

        if (waitForRemove.length > 0) {
          //从数组中删除
          for (let file of waitForRemove) {
            memo.files.splice(memo.files.indexOf(file), 1)
          }
        }

        //检查下传入的target.files ,如果有新增的 local_files,添加到memo.files里
        if (target.files) {
          for (let file of target.files) {
            if (DBUtil.isLocal(file.id) || file.id == 0) {
              memo.files.push(file)
            }
          }
        }

        if (!memo) {
          console.log('not found')
        }

        let promises = []
        promises.push(DBUtil.saveLinks(memo))
        promises.push(DBUtil.updateTag(memo))
        promises.push(DBUtil.saveFiles(memo))
        Promise.all(promises)
          .then(async () => {
            console.log('Promise.all1')

            let promiseArray = []
            promiseArray.push(db.memos.put(memo))

            //添加ACTION
            //本地还未同步的MEMO edit动作改为修改create
            if (memo.slug.indexOf('local_') >= 0) {
              let find_action = await db.memo_actions.where('slug').equals(memo.slug).first()
              if (find_action) find_action.content = memo.content
              db.memo_actions.put(find_action)
            } else {
              //多条edit记录只保留最后一条,老的全部删掉
              let find_actions = await db.memo_actions.where('slug').equals(memo.slug).toArray()
              for (let ac of find_actions) {
                if (ac.action == 'edit') {
                  db.memo_actions.delete(ac.id)
                }
              }

              let action = {
                action: 'edit',
                file_ids: target.file_ids,
                slug: target.slug,
                content: memo.content,
                memo_created_at: memo.created_at_long,
                action_date: DateUtil.todayLong(),
                pin: memo.pin,
              }
              promiseArray.push(db.memo_actions.put(action))

              if (DBUtil.isSyncing) {
                DBUtil.actionsNeedUpdateAfterSync.push(action)
              }
            }

            Promise.all(promiseArray)
              .then(() => {
                console.log('Promise.all2')
                DBUtil.notifyActionCountUpdate()
                console.log('ignoreSync', ignoreSync)
                if (!ignoreSync) {
                  DBUtil.sync()
                }
                memo.is_show_cloud = true

                //根据file_ids 重新组装 files -> 这时候新添加的file实际关联到该memo上,不能用parent_slug查询
                // let files = await db.files.where("id").anyOf(memo.file_ids).toArray();
                // memo.files = files;

                // DBUtil.prepareFiles(memo);
                // console.log("edit return:",memo);
                resolve(memo)
              })
              .catch((error) => {
                resolve(error)
              })
          })
          .catch((error) => {
            resolve(error)
          })
      })
    })
  }

  static pinMemo(target) {
    return new Promise(async (resolve) => {
      // 查找pin大于0
      let count = await db.memos.where('pin').above(0).count()
      // 找到pin最大的memo
      let maxPin = await db.memos.orderBy('pin').last()

      if (this.isProExpired() && count == 3) {
        resolve(false)
        return
      }
      if (count > 10) {
        resolve(false)
      } else {
        let find = await db.memos.get({ slug: target.slug })
        if (find.slug.indexOf('local_') >= 0) {
          resolve(false)
          return
        }

        find.pin = maxPin.pin++
        db.memos.put(find)

        let ignore = false
        //检查是否有未同步的 pin/unpin,如有则2个ACTION抵消,移除ACTION并不做任何处理
        let find_actions = await db.memo_actions.where('slug').equals(find.slug).toArray()
        for (let find_action of find_actions) {
          if (find_action.action == 'pin' || find_action.action == 'unpin') {
            db.memo_actions.delete(find_action.id)
            ignore = true
          }
        }

        if (!ignore) {
          let action = {
            action: 'pin',
            slug: target.slug,
            content: find.content,
            created_at: find.created_at_long,
            action_date: DateUtil.todayLong(),
          }
          db.memo_actions.put(action)
        }
        DBUtil.notifyActionCountUpdate()
        resolve(true)
        DBUtil.sync()
      }
    })
  }

  static unpinMemo(target) {
    return new Promise(async (resolve) => {
      let find = await db.memos.get({ slug: target.slug })
      if (find) {
        find.pin = 0
        db.memos.put(find)

        let ignore = false
        //检查是否有未同步的 pin/unpin,如有则2个ACTION抵消,移除ACTION并不做任何处理
        let find_actions = await db.memo_actions.where('slug').equals(find.slug).toArray()
        for (let find_action of find_actions) {
          if (find_action.action == 'pin' || find_action.action == 'unpin') {
            db.memo_actions.delete(find_action.id)
            ignore = true
          }
        }
        if (!ignore) {
          let action = {
            action: 'unpin',
            slug: target.slug,
            content: find.content,
            created_at: find.created_at_long,
            action_date: DateUtil.todayLong(),
          }
          db.memo_actions.put(action)
        }
        DBUtil.notifyActionCountUpdate()
        resolve(true)
        DBUtil.sync()
      } else {
        resolve(false)
      }
    })
  }

  static deleteMemo(target, isSync) {
    return new Promise(async (resolve) => {
      let find = await db.memos.get({ slug: target.slug })
      let deleteMemoSlugs = this.getLocalStorage('deleteMemoSlugs')
      if (deleteMemoSlugs != '' && deleteMemoSlugs != null) {
        deleteMemoSlugs = JSON.parse(deleteMemoSlugs)
      } else {
        deleteMemoSlugs = []
      }
      deleteMemoSlugs.push(target.slug)
      this.setLocalStorage('deleteMemoSlugs', JSON.stringify(deleteMemoSlugs))
      if (find) {
        find.deleted_at = DateUtil.today()
        find.deleted_at_long = DateUtil.todayLong()
        find.pin = 0

        await DBUtil.updateTag(find)

        db.memos.put(find)
        let ignore = false

        //检查是否有未同步的 CREATE/RESTORE ACTION,如有则2个ACTION抵消,移除ACTION并不做任何处理
        let find_actions = await db.memo_actions.where('slug').equals(find.slug).toArray()
        for (let find_action of find_actions) {
          if (find_action.action == 'create' || find_action.action == 'restore') {
            db.memo_actions.delete(find_action.id)
            ignore = true
          }
        }

        if (!ignore) {
          let action = {
            action: 'delete',
            slug: target.slug,
            content: find.content,
            created_at: find.created_at_long,
            action_date: DateUtil.todayLong(),
          }
          await db.memo_actions.put(action)
        }

        DBUtil.notifyActionCountUpdate()
        if (find.linked_memos && find.linked_memos.length) {
          DBUtil.handle_linked_memos(find.linked_memos)
        }

        if (isSync) {
          DBUtil.sync()
        }
        resolve(true)
      } else {
        resolve(false)
      }
    })
  }

  static restoreMemo(target) {
    return new Promise(async (resolve) => {
      let find = await db.memos.get({ slug: target.slug })
      let deleteMemoSlugs = JSON.parse(this.getLocalStorage('deleteMemoSlugs'))
      if (find) {
        if (deleteMemoSlugs) {
          deleteMemoSlugs.splice(deleteMemoSlugs.indexOf(target.slug), 1)
        } else {
          deleteMemoSlugs = []
        }
        this.setLocalStorage('deleteMemoSlugs', JSON.stringify(deleteMemoSlugs))
        find.deleted_at = null
        find.deleted_at_long = 0
        find.pin = 0

        let ignore = false

        if (find.slug.indexOf('local_') >= 0) {
          //如果是个local memo,那restore置换成 add 操作
          await db.memos.delete(find.id)
          delete find.id
          DBUtil.addMemo(find, true)
        } else {
          await DBUtil.updateTag(find)
          await DBUtil.saveFiles(find)
          db.memos.put(find)

          //检查是否有未同步的 DELETE ACTION,如有则2个ACTION抵消,移除ACTION并不做任何处理
          let find_actions = await db.memo_actions.where('slug').equals(target.slug).toArray()
          for (let find_action of find_actions) {
            if (find_action.action == 'delete') {
              db.memo_actions.delete(find_action.id)
              ignore = true
            }
          }

          if (!ignore) {
            let action = {
              action: 'restore',
              slug: target.slug,
              content: find.content,
              created_at: find.created_at_long,
              action_date: DateUtil.todayLong(),
            }
            db.memo_actions.put(action)
          }
        }

        DBUtil.notifyActionCountUpdate()
        DBUtil.sync()
        resolve(true)
      } else {
        resolve(false)
      }
    })
  }

  static getDeletedMemos(offset, limit) {
    return new Promise((resolve) => {
      let query = db.memos
      query = query.where('deleted_at_long').notEqual(0).reverse().sortBy('deleted_at_long')
      query.then(async (memos) => {
        memos = memos.filter((item) => {
          let current = new Date() / 1000
          return current - item.deleted_at_long < 3600 * 24 * 30
        })
        let result = memos.slice(offset, offset + limit)
        for (let item of result) {
          await DBUtil.isShowCloud(item)
          DBUtil.reformatDate(item)
        }
        resolve(result)
      })
    })
  }

  //获取置顶memo
  static getPinnedMemos() {
    return new Promise((resolve) => {
      let query = db.memos
      query = query.where('pin').above(0).reverse().sortBy('pin')
      query.then(async (result) => {
        if (!result) {
          resolve(result)
          return
        }

        let waitForCheck = []
        for (let item of result) {
          await DBUtil.prepareMemoLinks(item)
          await DBUtil.applyTags(item)
          await DBUtil.prepareFiles(item)
          await DBUtil.isShowCloud(item)
          DBUtil.reformatDate(item)
          if (item.files) waitForCheck = waitForCheck.concat(item.files)
        }
        let refreshFiles = await DBUtil.checkImageUrl(waitForCheck)
        let memosNeedRefresh = []
        if (refreshFiles && refreshFiles.length > 0) {
          for (let item of result) {
            if (item.files) {
              for (let i = 0; i < item.files.length; i++) {
                let file = item.files[i]
                let needRefresh = false
                for (let refreshFile of refreshFiles) {
                  if (refreshFile.id == file.id) {
                    item.files.splice(i, 1, refreshFile)
                    needRefresh = true
                  }
                }
                if (needRefresh) memosNeedRefresh.push(item)
              }
            }
          }
        }

        resolve(result)

        //更新到数据库
        if (refreshFiles && refreshFiles.length > 0) {
          //更新file表
          db.files.bulkPut(refreshFiles)
          db.memos.bulkPut(memosNeedRefresh)
        }
      })
    })
  }

  static async getTags() {
    if (DBUtil.isInit) {
      let tags = []
      for (let key in DBUtil.initTagMap) {
        tags.push({ name: key })
      }
      tags.push({ name: '', count: 0 })
      await DBUtil.mergeTags(tags, DBUtil.initTagInfos)
      return tags
    } else {
      return new Promise(async (resolve) => {
        let tags = await db.tags.where('count').above(0).toArray()
        tags.push({ name: '', count: 0 })
        let tagInfos = await db.tagInfos.toArray()
        await DBUtil.mergeTags(tags, tagInfos)
        resolve(tags)
      })
    }
  }

  static async mergeTags(tags, tagInfos) {
    //merge tagInfos
    for (let tag of tags) {
      for (let tagInfo of tagInfos) {
        if (tag.name == tagInfo.name) {
          tag.icon_type = tagInfo.icon_type
          tag.icon_value = tagInfo.icon_value
          tag.pin = tagInfo.pin
          tag.order = tagInfo.order ? tagInfo.order : null
          tag.has_info = true
        }
      }
      let value = default_emoji_data[tag.name]

      // 无tagInfo 应用彩蛋配置
      if (!tag.icon_value && !tag.has_info) {
        tag.icon_type = 'emoji'
        tag.icon_value = value
      }
      // 有服务端配置,服务端配置为-1时,强制icon为空,配置为null时,也可应用彩蛋配置
      else if (tag.has_info && tag.icon_value == null) {
        tag.icon_type = 'emoji'
        tag.icon_value = value
      }
    }

    await DBUtil.sortTags(tags)
    DBUtil.filterTag(tags)
  }

  static getPinnedTags() {
    return new Promise(async (resolve) => {
      let tags = await db.tagInfos.where('pin').equals(1).toArray()
      await DBUtil.sortTags(tags)

      for (let tag of tags) {
        let value = default_emoji_data[tag.name]
        if (!tag.icon_value || tag.icon_value == null) {
          tag.icon_type = 'emoji'
          tag.icon_value = value
        }
      }
      resolve(tags)
    })
  }

  static async sortTags(tags) {
    let regNumber = /\d+/ //验证0-9的任意数字最少出现1次。
    let regStringUpper = /[A-Z]+/ //验证大写
    let regStringLower = /[a-z]+/ //验证小写
    let regChinese = /[\u4E00-\u9FA5]/

    await tags.sort((a, b) => {
      // 按照sort 大于0，desc 排序
      //if (a.order > 0 && b.order > 0) {
      //  return a.order - b.order
      //} else if (a.order > 0) {
      //  return -1
      //} else if (b.order > 0) {
      //  return 1
      //}

      //按 其它特殊符号 -> 数字 -> 大写字母 -> 小写字母 -> 汉字
      if (!a.name && !b.name) {
        return 0
      } else if (!a.name) {
        return -1
      } else if (!b.name) {
        return 1
      }

      let af = a.name.toString().substring(0, 1) //首字母
      let bf = b.name.toString().substring(0, 1) //首字母
      let al, bl
      if (regNumber.test(af)) {
        al = 10
      } else if (regStringUpper.test(af)) {
        al = 100
      } else if (regStringLower.test(af)) {
        al = 1000
      } else if (!regChinese.test(af)) {
        al = 0
      } else {
        al = 10000
      }

      if (regNumber.test(bf)) {
        bl = 10
      } else if (regStringUpper.test(bf)) {
        bl = 100
      } else if (regStringLower.test(bf)) {
        bl = 1000
      } else if (!regChinese.test(bf)) {
        bl = 0
      } else {
        bl = 10000
      }

      if (al == bl && al == 10000) {
        return a.name.toString().localeCompare(b.name.toString(), 'zh')
      } else if (al == bl) {
        return a.name.toString().localeCompare(b.name.toString())
      } else {
        return al - bl
      }
    })
  }

  static async sortChildren(tags) {
    let regNumber = /\d+/ //验证0-9的任意数字最少出现1次。
    let regStringUpper = /[A-Z]+/ //验证大写
    let regStringLower = /[a-z]+/ //验证小写
    let regChinese = /[\u4E00-\u9FA5]/

    await tags.sort((a, b) => {
      // 按照sort 从小到大排序
      //if (a.order > 0 && b.order > 0) {
      //  return a.order - b.order
      //} else if (a.order > 0) {
      //  return -1
      //} else if (b.order > 0) {
      //  return 1
      //}

      //按 其它特殊符号 -> 数字 -> 大写字母 -> 小写字母 -> 汉字
      if (!a.display && !b.display) {
        return 0
      } else if (!a.display) {
        return -1
      } else if (!b.display) {
        return 1
      }

      let af = a.display.toString().substring(0, 1) //首字母
      let bf = b.display.toString().substring(0, 1) //首字母
      let al, bl
      if (regNumber.test(af)) {
        al = 10
      } else if (regStringUpper.test(af)) {
        al = 100
      } else if (regStringLower.test(af)) {
        al = 1000
      } else if (!regChinese.test(af)) {
        al = 0
      } else {
        al = 10000
      }

      if (regNumber.test(bf)) {
        bl = 10
      } else if (regStringUpper.test(bf)) {
        bl = 100
      } else if (regStringLower.test(bf)) {
        bl = 1000
      } else if (!regChinese.test(bf)) {
        bl = 0
      } else {
        bl = 10000
      }

      if (al == bl && al == 10000) {
        return a.display.toString().localeCompare(b.display.toString(), 'zh')
      } else {
        return al - bl
      }
    })
  }

  static isChinese(char) {
    var re = /[^\u4E00-\u9FA5]/
    if (re.test(char)) return false
    return true
  }

  //给Memos重新组装tag file
  static async prepareMemoLinks(memo) {
    let slug = memo.slug
    let links = await db.links.where('source').equals(slug).toArray()
    let backlinks = await db.links.where('link').equals(slug).toArray()
    memo.linked_memos = []
    memo.backlinked_memos = []

    if (links) {
      let linked_memos = await db.memos
        .where('slug')
        .anyOf(links.map((link) => link.link))
        .toArray()
      DBUtil.removeLinks(linked_memos)

      linked_memos.sort((a, b) => {
        if (!a.created_at_long) a.created_at_long = 0
        if (!b.created_at_long) b.created_at_long = 0

        return a.created_at_long - b.created_at_long
      })

      memo.linked_memos = linked_memos
    }
    if (backlinks) {
      let backlinked_memos = await db.memos
        .where('slug')
        .anyOf(backlinks.map((link) => link.source))
        .toArray()
      DBUtil.removeLinks(backlinked_memos)

      backlinked_memos.sort((a, b) => {
        if (!a.created_at_long) a.created_at_long = 0
        if (!b.created_at_long) b.created_at_long = 0

        return a.created_at_long - b.created_at_long
      })

      memo.backlinked_memos = backlinked_memos.filter((memo) => {
        return !memo.deleted_at
      })
    }
  }

  //防止循环引用
  static removeLinks(memos) {
    if (!memos) return

    for (let memo of memos) {
      memo.linked_memos = []
      memo.backlinked_memos = []
    }
  }

  static async isShowCloud(memo) {
    // let count = await db.memo_actions.where("slug").equals(memo.slug).count();
    // safari ios 14.x 有个奇怪的bug,这里命名数据库里整个memo_actions表都是空的,count却会返回 1/2 之类的数字
    let actions = await db.memo_actions.where('slug').equals(memo.slug).toArray()
    let count = actions.length
    memo.is_show_cloud = count > 0 ? true : false
  }

  static reformatDate(memo) {
    if (memo.created_at_long > 0) memo.created_at = DateUtil.formatSecondsToDateString(memo.created_at_long)
    if (memo.updated_at_long > 0) memo.updated_at = DateUtil.formatSecondsToDateString(memo.updated_at_long)
    if (memo.deleted_at_long > 0) memo.deleted_at = DateUtil.formatSecondsToDateString(memo.deleted_at_long)
  }

  //处理下local file
  static async prepareFiles(memo) {
    if (memo && memo.files && memo.files.length > 0) {
      for (let file of memo.files) {
        if (file.id == 0 || DBUtil.isLocal(file.id)) {
          file.blob = file.param
        }
      }
    }
  }

  // 保存 link change
  static async saveLinks(memo, isNew) {
    let content = memo.content
    let newlinks = []
    if (content) {
      newlinks = DBUtil.parseLinks(content)
    }
    if (!isNew) {
      let find = await db.memos.get({ slug: memo.slug })
      if (find) {
        //更新
        //先把老的全删了
        let oldLinks = await db.links.where('source').equals(memo.slug).toArray()
        if (oldLinks) await db.links.bulkDelete(oldLinks.map((link) => link.id))
      }
    }

    //单纯新增
    memo.links = newlinks
    let linked_memos = []
    if (newlinks && newlinks.length > 0) {
      for (let link of newlinks) {
        if (
          link.indexOf('https://flomoapp.com/mine/?memo_id=') >= 0 ||
          link.indexOf('https://v.flomoapp.com/mine/?memo_id=') >= 0
        ) {
          let memo_slug = DBUtil.getQueryVariable(link, 'memo_id')
          if (memo_slug) {
            let find = await DBUtil.getMemo(memo_slug)
            if (find) {
              linked_memos.push(find)
            }
            await db.links.put({ source: memo.slug, link: memo_slug })
          }
        } else {
          await db.links.put({ source: memo.slug, link: link })
        }
      }
    }
    DBUtil.removeLinks(linked_memos)
    memo.linked_memos = DBUtil.filterLink(linked_memos)
  }

  // 保存 File
  static async saveFiles(memo, isNew) {
    if (!isNew) {
      let finds = await db.files.where('parent_slug').equals(memo.slug).toArray()
      if (finds) {
        //更新
        //先把老的全删了
        if (finds) await db.files.bulkDelete(finds.map((file) => file.id))
      }
    }

    //单纯新增
    if (memo && memo.files && memo.deleted_at_long == 0) {
      let index = 0
      for (let file of memo.files) {
        file.parent_slug = memo.slug
        file.index = index

        //说明是个新增的本地file  先随机分配个 id
        if (file.id == 0) {
          file.id = Math.trunc(Number.MAX_VALUE * (0.5 + 0.5 * Math.random()))
        }
        index++
      }
      await db.files.bulkPut(memo.files)
    }
  }

  static async updateTag(memo, isNew) {
    let start = +new Date()
    if (!isNew) {
      let find = await db.memos.get({ slug: memo.slug })
      //如果已经存在,先减掉老的 tags 计数
      if (find && find.tags && find.deleted_at_long == 0) {
        //更新
        //老的tags - 1
        for (let tag of find.tags) {
          let find = await db.tags.get({ name: tag })
          if (find) {
            find.count = find.count - 1
            await db.tags.put(find)
          } else {
            console.log('not found:' + tag)
          }
        }
      }
    }

    //apply 新memos的计数
    DBUtil.applyTags(memo)

    if (memo.deleted_at_long == 0 && memo.tags != null) {
      //初始化所有Tag操作内存中进行
      if (DBUtil.isInit) {
        for (let tag of memo.tags) {
          if (DBUtil.initTagMap[tag]) {
            DBUtil.initTagMap[tag] = DBUtil.initTagMap[tag] + 1
          } else {
            DBUtil.initTagMap[tag] = 1
          }
        }
      } else {
        let finds = await db.tags.where('name').anyOf(memo.tags).toArray()
        for (let tag of memo.tags) {
          let find
          for (let f of finds) {
            if (f.name == tag) {
              find = f
              break
            }
          }

          if (find) {
            find.count = find.count + 1
            find.latest_used_at = memo.created_at_long
            await db.tags.put(find)
          } else {
            await db.tags.put({
              name: tag,
              count: 1,
              latest_used_at: memo.created_at_long,
            })
          }
        }
      }
    }

    let end = +new Date()
    DBUtil.tagTotal += end - start
  }

  static applyTags(memo) {
    let tags = DBUtil.parseTags(memo.content)
    memo.tags = []
    if (tags && tags.length > 0) {
      for (let index = 0; index < tags.length; index++) {
        let tag = tags[index].substring(1)
        // if (tag.endsWith('/')) {
        //   tag = tag.substring(0, tag.length - 1)
        // }
        memo.tags.push(tag)
        if (tag.indexOf('/') > 0) {
          let arr = tag.split('/')
          let temp = ''
          //最后一个已经加进去了  所以遍历到倒数第二个即可
          for (let i = 0; i < arr.length - 1; i++) {
            memo.tags.push(temp + arr[i])
            temp = temp + arr[i] + '/'
          }
        }
      }
    } else {
      memo.tags = []
    }
    memo.tags = Array.from(new Set(memo.tags))
  }

  static pinTag(name) {
    return new Promise((resolve) => {
      db.tagInfos.get({ name: name }).then((tagInfo) => {
        if (tagInfo) {
          tagInfo.pin = 1
          db.tagInfos.put(tagInfo)
        } else {
          tagInfo = {
            id: Math.trunc(Number.MAX_VALUE * (0.5 + 0.5 * Math.random())),
            name: name,
            pin: 1,
          }
          db.tagInfos.put(tagInfo)
        }

        db.tag_actions.put({ name: name, action: 'pin' })
        DBUtil.notifyActionCountUpdate()
        DBUtil.sync()
        resolve(tagInfo)
      })
    })
  }

  static unpinTag(name) {
    return new Promise((resolve) => {
      db.tagInfos.get({ name: name }).then((tagInfo) => {
        if (tagInfo) {
          tagInfo.pin = 0
          db.tagInfos.put(tagInfo)
        } else {
          tagInfo = {
            id: Math.trunc(Number.MAX_VALUE * (0.5 + 0.5 * Math.random())),
            name: name,
            pin: 0,
          }
          db.tagInfos.put(tagInfo)
        }

        db.tag_actions.put({ name: name, action: 'unpin' })
        DBUtil.notifyActionCountUpdate()
        DBUtil.sync()
        resolve(tagInfo)
      })
    })
  }

  static changeTagIcon(name, emoji) {
    return new Promise((resolve) => {
      // 移除 emoji 不需要pro
      if (!this.isProExpired() && emoji !== -1) {
        resolve(false)
        return
      }
      db.tagInfos.get({ name: name }).then((tagInfo) => {
        if (tagInfo) {
          console.log('find tagInfos', tagInfo)
          if (emoji) {
            tagInfo.icon_type = 'emoji'
            tagInfo.icon_value = emoji
          } else {
            tagInfo.icon_type = null
            tagInfo.icon_value = -1
          }
          db.tagInfos.put(tagInfo)
        } else {
          console.log('not found tagInfos', tagInfo)
          tagInfo = {
            id: Math.trunc(Number.MAX_VALUE * (0.5 + 0.5 * Math.random())),
            name: name,
            icon_type: emoji && emoji != -1 ? 'emoji' : null,
            icon_value: emoji && emoji != -1 ? emoji : -1,
          }
          db.tagInfos.put(tagInfo)
        }

        db.tag_actions.put({
          name: name,
          tag_id: tagInfo.id,
          action: 'change_icon',
          icon_type: emoji && emoji != -1 ? 'emoji' : null,
          icon_value: emoji && emoji != -1 ? emoji : -1,
        })
        DBUtil.notifyActionCountUpdate()
        DBUtil.sync()
        resolve(tagInfo)
      })
    })
  }

  static renameTag(oldName, newName, order) {
    return new Promise(async (resolve) => {
      if (DBUtil.isSyncing) {
        resolve(false)
        return
      }

      if (order == null) {
        let memos = await db.memos
          .where('tags')
          .notEqual([])
          .filter((item) => {
            return item.tags.indexOf(oldName) > -1 && item.deleted_at_long == 0
          })
          .toArray()

        if (memos) {
          for (let memo of memos) {
            let replaceReg = DBUtil.escapeExprSpecialWord(oldName)
            memo.content = memo.content.replaceAll('#' + replaceReg, '#' + newName)
            if (memo.files)
              memo.file_ids = memo.files.map((file) => {
                return file.id
              })
            await DBUtil.editMemo(memo, true)
          }
        }
      }

      if (newName) {
        //更新TagInfo
        let tagInfo = await db.tagInfos.get({ name: oldName })
        let newTagInfo = await db.tagInfos.get({ name: newName })

        let action = {
          action: 'rename',
          name: oldName,
          rename: newName,
          order: tagInfo ? tagInfo.order : order,
        }

        if (!newTagInfo) {
          if (tagInfo) {
            action.tag_id = tagInfo.id
            tagInfo.name = newName
            await db.tagInfos.put(tagInfo)
          }
        }

        await DBUtil.mergeTagAction(action)

        //如果这个Tag有子Tag,则也需要同步修改
        let subs = await db.tagInfos
          .where('name')
          .startsWith(oldName + '/')
          .toArray()
        if (subs) {
          for (let sub of subs) {
            let name = sub.name
            let replaceReg = DBUtil.escapeExprSpecialWord(oldName)
            name = name.replaceAll(replaceReg, newName)
            sub.name = name
            let newSubTagInfo = await db.tagInfos.get({ name: sub.name })
            //如果rename后的 tagInfo已经存在 忽略这个修改
            if (!newSubTagInfo) await db.tagInfos.put(sub)
          }
        }
      } else {
        let tagInfo = await db.tagInfos.get({ name: oldName })
        let action = {
          action: 'rename',
          name: oldName,
          rename: oldName,
          order: order,
          tag_id: tagInfo && tagInfo.id ? tagInfo.id : '',
        }
        await DBUtil.mergeTagAction(action)
      }

      DBUtil.sync()
      resolve(true)
    })
  }

  static async mergeTagAction(newAction) {
    let info = await db.tagInfos.get({ name: newAction.name })
    if (!info && newAction.rename) info = await db.tagInfos.get({ name: newAction.rename })
    let oldActions
    if (newAction.tag_id) {
      oldActions = await db.tag_actions.where('tag_id').equals(newAction.tag_id).toArray()
    }

    if (info != null && !DBUtil.isLocal(info.id)) {
      //有id 执行顺序无所谓
      db.tag_actions.put(newAction)
      DBUtil.notifyActionCountUpdate()
    } else {
      //没有id ,如果之前有 pin / change icon 动作,  那无需rename, pin / change icon 直接对修改后的name操作
      //这个 new action 不需要实际执行
      if (newAction.action == 'rename' && oldActions) {
        for (let oldAction of oldActions) {
          if (oldAction.action == 'pin' || oldAction.action == 'unpin' || oldAction.action == 'change_icon') {
            oldAction.name = newAction.rename
            db.tag_actions.put(oldAction)
          }
        }
      }
      //如果不是rename操作,则无所谓
      else if (newAction.action != 'rename') {
        db.tag_actions.put(newAction)
      } else {
        db.tag_actions.put(newAction)
        DBUtil.notifyActionCountUpdate()
      }
      DBUtil.notifyActionCountUpdate()
    }
  }
  // 删除标签及标签下的所有memo
  static deleteMemosOfTag(name) {
    return new Promise(async (resolve) => {
      if (DBUtil.isSyncing) {
        resolve(false)
        return
      }

      let tag = await db.tags.get({ name: name })
      if (tag) {
        let memos = await db.memos
          .where('tags')
          .notEqual([])
          .filter((item) => {
            return item.tags.indexOf(name) > -1 && item.deleted_at_long == 0
          })
          .toArray()
        if (memos) {
          memos.map(async (memo) => {
            await DBUtil.deleteMemo(memo, false)
          })
        }

        //更新TagInfo 删除时 如果是pinned tag就调用一次unpin
        let tagInfo = await db.tagInfos.get({ name: name })
        if (tagInfo) {
          if (tagInfo.pin == 1) {
            tagInfo.pin = 0
            let action = { action: 'unpin', tag_id: tagInfo.id, name: name }
            await db.tagInfos.put(tagInfo)
            //删除了一个pinned tag
            this.setLocalStorage('deletePinnedTag', name)
            await DBUtil.mergeTagAction(action)
          }
        }
        // 删除tag
        db.tags.delete(tag.id)
      }
      // 执行太快,会导致 getMemoList 获取不到最新的数据
      setTimeout(() => {
        DBUtil.notifyActionCountUpdate()
        emitter.emit('memo-list-updated')
        DBUtil.sync()
        resolve(true)
      }, 1000)
    })
  }

  // 撤销删除
  static undoDeleteMemo() {
    return new Promise(async (resolve) => {
      if (DBUtil.isSyncing) {
        resolve(false)
        return
      }
      let deleteMemoSlugs = JSON.parse(localStorage.getItem('deleteMemoSlugs'))

      deleteMemoSlugs.map(async (slug, index) => {
        // 防止同时插入updateTag查询有问题
        setTimeout(async () => {
          await DBUtil.restoreMemo({ slug })
        }, index * 100)
      })

      let deletedPinnedTag = localStorage.getItem('deletePinnedTag')
      if (deletedPinnedTag) {
        let tagInfo = await db.tagInfos.get({ name: deletedPinnedTag })
        if (tagInfo) {
          if (tagInfo.pin == 0) {
            tagInfo.pin = 1
            let action = {
              action: 'pin',
              tag_id: tagInfo.id,
              name: deletedPinnedTag,
            }
            await db.tagInfos.put(tagInfo)
            //恢复这个taginfo 的 pin 状态
            this.clearDeleteTag()
            await DBUtil.mergeTagAction(action)
          }
        }
      }

      DBUtil.notifyActionCountUpdate()
      // 执行太快,会导致 getMemoList 获取不到最新的数据
      setTimeout(() => {
        emitter.emit('memo-list-updated')
        resolve(true)
        DBUtil.sync()
      }, 1000)
    })
  }

  //转义
  static escapeExprSpecialWord(str) {
    return str.replace(/[\-\/\\\^\$\*\+\?\.\(\)\|\[\]\{\}]/g, '\\$&')
  }

  static async getStats() {
    let memos
    if (DBUtil.isInit) {
      memos = DBUtil.initMemos.filter((item) => {
        return item.deleted_at_long == 0
      })
    } else {
      memos = await db.memos.where('deleted_at_long').equals(0).toArray()
    }
    let map = {}
    for (let memo of memos) {
      let date = DateUtil.formatDateStringToDateOnly(memo.created_at)
      if (map[date]) {
        map[date] = map[date] + 1
      } else {
        map[date] = 1
      }
    }
    return map
  }

  static async getMemoCount() {
    if (DBUtil.isInit) {
      let count = DBUtil.initMemos.filter((item) => {
        return item.deleted_at_long == 0
      }).length
      return count
    } else {
      return await db.memos.where('deleted_at_long').equals(0).count()
    }
  }

  static filterLink(arr) {
    let deWeightThree = () => {
      let map = new Map()
      for (let item of arr) {
        if (!map.has(item)) {
          map.set(item, item)
        }
      }
      return [...map.values()]
    }
    return deWeightThree()
  }

  static filterFiles(arr) {
    let deWeightThree = () => {
      let map = new Map()
      for (let file of arr) {
        if (!map.has(file.id)) {
          map.set(file.id, file)
        }
      }
      return [...map.values()]
    }
    return deWeightThree()
  }

  static filterTag(arr) {
    let deWeightThree = () => {
      let map = new Map()
      for (let tag of arr) {
        if (!map.has(tag.name)) {
          map.set(tag.name, tag)
        }
      }
      return [...map.values()]
    }
    return deWeightThree()
  }

  static async getTotalActionCount() {
    return (await db.memo_actions.count()) + (await db.tag_actions.count())
  }

  static async loadLatestTagNames() {
    let tags = await db.tags.where('count').above(0).toArray()
    tags.sort((a, b) => {
      if (!a.latest_used_at) a.latest_used_at = 0
      if (!b.latest_used_at) b.latest_used_at = 0

      return b.latest_used_at - a.latest_used_at
    })

    let arr = []
    for (let i = 0; i < tags.length && i < 10; i++) {
      arr.push(tags[i].name)
    }
    return arr
  }

  static parseLinks(content) {
    if (content) {
      var reg = /(https?|http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
      return content.match(reg)
    } else {
      return []
    }
  }

  static isLocal(id) {
    return id >= Number.MAX_VALUE / 2
  }

  static parseTags(origin) {
    if (origin) {
      //clean 异常字符
      let content = origin.replaceAll('&nbsp;', ' ')
      content = content.replaceAll('\u{00a0}', ' ')
      content = content.replaceAll('/\xc2\xa0/', '')

      var reg = /#([^\s<#]+)/g
      let reText = content.replace(/(https?:\/\/([^\s<\/\#)）]+)[^\s<)）]*)/g, '') // 过滤掉链接
      return reText.match(reg)
    } else {
      return []
    }
  }

  static getQueryVariable(url, key) {
    if (url.indexOf('?') >= 0 && url.indexOf('?') < url.length - 1) {
      var query = url.substring(url.indexOf('?') + 1)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] == key) {
          return pair[1]
        }
      }
    }
    return false
  }

  //确定这些图片要不要更新
  static async checkImageUrl(files) {
    if (files != null) {
      let waitForRefreshFiles = []
      for (let file of files) {
        let isExpire = DBUtil.isFileExpire(file)

        if (isExpire) {
          waitForRefreshFiles.push(file)
        }
      }

      if (waitForRefreshFiles.length > 0) {
        return await DBUtil.refreshFiles(waitForRefreshFiles)
      }
    }
    return []
  }

  static isFileExpire(file) {
    let isExpire = false
    if (file.url != null) {
      let expire_at = DBUtil.getQueryVariable(file.url, 'Expires')
      if (expire_at) {
        isExpire = DateUtil.todayLong() - expire_at > 0
      }
    }
    return isExpire
  }

  //更新图片签名
  static refreshFiles(files) {
    return new Promise((resolve) => {
      let id_array = files.map((file) => {
        return file.id
      })
      //get 请求有最大 url长度限制
      api.call(
        'GET',
        '/file/',
        {
          ids: id_array,
        },
        (response) => {
          if (response.data && response.data.code === -1) {
            resolve([])
          } else if (response.data && response.data.code === 0) {
            let files = response.data.data
            resolve(files)
          } else {
            resolve([])
          }
        },
      )
    })
  }

  //logout时 需清空数据库
  static resetDB() {
    return db.delete()
  }

  static async clearDB() {
    await db.memos.clear()
    await db.links.clear()
    await db.tags.clear()
    await db.files.clear()
    await db.memo_actions.clear()
    await db.tag_actions.clear()
    await db.memo_content_histories.clear()
    await db.tagInfos.clear()
  }

  static hashCode(strKey) {
    var hash = 0
    if (!DBUtil.isNull(strKey)) {
      strKey = strKey.replaceAll('&nbsp;', ' ')
      for (var i = 0; i < strKey.length; i++) {
        hash = hash * 31 + strKey.charCodeAt(i)
        hash = DBUtil.intValue(hash)
      }
    }
    return hash
  }

  static isNull(str) {
    return str == null || str.value == ''
  }

  static intValue(num) {
    var MAX_VALUE = 0x7fffffff
    var MIN_VALUE = -0x80000000
    if (num > MAX_VALUE || num < MIN_VALUE) {
      return (num &= 0xffffffff)
    }
    return num
  }

  static uploadFile(param, callback) {
    let signPro = new Promise((resolve, rej) => {
      var res = JSON.parse(localStorage.getItem('oss_sign'))
      var timestamp = Date.parse(new Date()) / 1000
      if (res && res.expire - 10 > timestamp) {
        // 签名未过期，则直接上传
        resolve(res)
      } else {
        // 签名过期，则重新获取，再上传
        api.call('GET', '/file/oss_signature', {}, (response) => {
          if (response.data && response.data.code === 0) {
            localStorage.setItem('oss_sign', JSON.stringify(response.data.data.signature))
            resolve(response.data.data)
          }
        })
      }
    })
    signPro.then((success) => {
      if (param.onProgress instanceof Function) {
        param.onProgress({ percent: 50 })
      }
      var data = success
      var ossData = new FormData()
      ossData.append('name', param.file.name)
      console.log(param.file)
      //获取图片类型 后缀 jpg / png
      if (param.file && param.file.type) {
        let imgType = param.file.type.split('/')[1]
        let filename = param.file.name + param.file.size + Math.random() //md5对图片名称进行加密
        let keyValue = data.dir + '/' + md5(filename) + '.' + imgType
        //文件名
        ossData.append('key', keyValue)
        ossData.append('policy', data.policy)
        ossData.append('OSSAccessKeyId', data.accessid)
        ossData.append('success_action_status', 201)
        ossData.append('signature', data.signature)
        ossData.append('file', param.file, param.file.name)
        axios
          .post(data.host, ossData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            if (param.onProgress instanceof Function) {
              param.onProgress({ percent: 80 })
            }
            if (res.status == 201) {
              //上传成功 上传的路径就是要使用的路径
              // 保存 File
              api.call(
                'PUT',
                '/file/',
                {
                  name: param.file.name,
                  size: param.file.size,
                  path: keyValue,
                },
                (response) => {
                  if (response.data && response.data.code === 0) {
                    // let file = response.data.data;
                    // db.files.put(file);  //此时文件在temp目录下,不要保存它的地址
                    param.id = response.data.data.id
                    if (param.onSuccess instanceof Function) {
                      param.onSuccess(response.data.data)
                    }
                    if (callback) {
                      callback(response.data.data)
                    }
                  }
                },
              )
            }
          })
          .catch((error) => {
            console.log(error)
            if (callback) {
              callback(false, error)
            }
          })
      } else {
        callback(false)
      }
    })
  }

  static sleep(time) {
    if (time <= 0) return 0
    return new Promise((resolve) => setTimeout(resolve, time))
  }

  static setLocalStorage(key, value) {
    localStorage.setItem(key, value)
  }

  static getLocalStorage(key) {
    return localStorage.getItem(key)
  }

  // 清空 deleteMemoSlugs
  static clearDeleteMemoSlugs() {
    this.setLocalStorage('deleteMemoSlugs', '[]')
  }
  // 清空 deletePinnedTag
  static clearDeleteTag() {
    this.setLocalStorage('deletePinnedTag', '')
  }

  static async getLastSyncTime() {
    let memo = await db.memos.orderBy('updated_at_long').reverse().first()
    if (memo) return memo.updated_at_long
    else return '0' //数字0在签名时会被视为false导致签名错误
  }

  static async getTagLastSyncTime() {
    let tagInfo = await db.tagInfos.orderBy('updated_at').reverse().first()
    if (tagInfo) {
      let updated_at_long = DateUtil.formatDateStringToSeconds(tagInfo.updated_at)
      return updated_at_long
    } else return '0' //数字0在签名时会被视为false导致签名错误
  }

  // 判断用户pro 是否过期
  static isProExpired() {
    let user = this.getLocalStorage('me')
    if (user) {
      let proExpired = JSON.parse(user).pro_expired_at
      if (proExpired) {
        return dayjs(proExpired).isAfter(dayjs())
      } else {
        return false
      }
    } else {
      return false
    }
  }

  // 获取用户创建时间
  static getUserCreatedAt() {
    let user = this.getLocalStorage('me')
    if (user) {
      let createdAt = JSON.parse(user).created_at
      if (createdAt) {
        return createdAt
      } else {
        return false
      }
    } else {
      return false
    }
  }

  static async refreshMemoFiles(find) {
    let waitForCheck = []
    if (find.files) waitForCheck = waitForCheck.concat(find.files)

    for (let memo of find.linked_memos) {
      if (memo.files) waitForCheck = waitForCheck.concat(memo.files)
    }
    for (let memo of find.backlinked_memos) {
      if (memo.files) waitForCheck = waitForCheck.concat(memo.files)
    }

    let refreshFiles = await DBUtil.checkImageUrl(waitForCheck)
    let memosNeedRefresh = []
    if (refreshFiles && refreshFiles.length > 0) {
      let memos = []
      if (find.linked_memos) memos = memos.concat(find.linked_memos)
      if (find.backlinked_memos) memos = memos.concat(find.backlinked_memos)
      memos.push(find)

      for (let item of memos) {
        if (item.files) {
          for (let i = 0; i < item.files.length; i++) {
            let file = item.files[i]
            let needRefresh = false
            for (let refreshFile of refreshFiles) {
              if (refreshFile.id == file.id) {
                item.files.splice(i, 1, refreshFile)
                needRefresh = true
              }
            }
            if (needRefresh) memosNeedRefresh.push(item)
          }
        }
      }
    }

    //更新到数据库
    if (refreshFiles && refreshFiles.length > 0) {
      //更新file表
      db.files.bulkPut(refreshFiles)
      db.memos.bulkPut(memosNeedRefresh)
    }

    return find
  }

  static checkEstimatedQuota() {
    return new Promise(async (resolve) => {
      let storage = navigator.storage
      if (storage && storage.estimate) {
        const estimation = await storage.estimate()
        console.log(`Quota: ${estimation.quota}`)
        console.log(`Usage: ${estimation.usage}`)

        if (estimation.usage > estimation.quota) {
          resolve(false)
        } else {
          resolve(true)
        }
        //无冗余数据时,约等于1.5w条MEMO左右
        if (estimation.usage > 50 * 1024 * 1024) {
          DBUtil.needClean = true
        }
      } else {
        console.error('StorageManager not found')
        resolve(true)
      }
    })
  }

  //清空冗余数据
  static cleanDB() {
    console.log('clean db')
    let query = db.memos.toArray()
    query.then(async (memos) => {
      for (let memo of memos) {
        //清空links数据,实际使用时由links表查表重新组装. 清除之前Bug造成的循环引用.
        memo.backlinked_memos = []
        memo.linked_memos = []

        //非local memo上挂载有blob图片 一并删除
        if (!memo.slug.startsWith('local_')) {
          let waitForRemove = []
          for (let file of memo.files) {
            if (DBUtil.isLocal(file.id)) {
              waitForRemove.push(file)
            }
          }
          if (waitForRemove.length > 0) {
            //从数组中删除
            for (let file of waitForRemove) {
              memo.files.splice(memo.files.indexOf(file), 1)
            }
          }
        }
      }
      await db.memos.bulkPut(memos)
      DBUtil.needClean = false
    })
  }
  static editMemoDirect(slug, content, source, file_ids, pin) {
    console.log('editMemoDirect')
    return new Promise(async (resolve) => {
      file_ids = Array.from(new Set(file_ids))
      api.call(
        'PUT',
        '/memo/' + slug,
        {
          content,
          local_updated_at: DateUtil.todayLong(),
          source,
          file_ids,
          tz: DateUtil.getTz(),
          pin,
        },
        (response) => {
          if (response.data && response.data.code === -1) {
            resolve(false)
          } else if (response.data && response.data.code === -20) {
            resolve(true)
          } else if (response.data && response.data.code === 0) {
            resolve(response.data.data)
          } else {
            resolve(false)
          }
        },
      )
    })
  }

  static pinMemoDirect(target) {
    console.log('pinMemoDirect')
    return new Promise(async (resolve) => {
      api.call('POST', '/memo/' + target.slug + '/pin', {}, (response) => {
        try {
          if (response.data && response.data.code === -1) {
            resolve(true)
          } else if (response.data && response.data.code === 0) {
            resolve(true)
          } else {
            resolve(false)
          }
        } catch (error) {
          console.log(error)
          resolve(false)
        }
      })
    })
  }

  static unpinMemoDirect(target) {
    console.log('unpinMemoDirect')
    return new Promise(async (resolve) => {
      api.call(
        'POST',
        '/memo/' + target.slug + '/unpin',
        {
          force: 1,
        },
        (response) => {
          try {
            if (response.data && response.data.code === -1) {
              resolve(true)
            } else if (response.data && response.data.code === 0) {
              resolve(true)
            } else {
              resolve(false)
            }
          } catch (error) {
            console.log(error)
            resolve(false)
          }
        },
      )
    })
  }

  static deleteMemoDirect(target) {
    console.log('deleteMemoDirect')
    return new Promise(async (resolve) => {
      api.call('DELETE', '/memo/' + target.slug, {}, (response) => {
        try {
          if (response.data && response.data.code === -1) {
            resolve(true)
          } else if (response.data && response.data.code === 0) {
            resolve(true)
          } else {
            resolve(false)
          }
        } catch (error) {
          console.log(error)
          resolve(false)
        }
      })
    })
  }

  // 获取最近一年的 memo 数量
  static getMemoCountByYear() {
    return new Promise((resolve) => {
      const query = db.memos.where('created_at_long').aboveOrEqual(DateUtil.yearAgoLong()).toArray()
      query.then((memos) => {
        memos = memos.filter(function (item) {
          return !item.deleted_at
        })

        let count = memos.length
        let memoCountByDay = {}
        let wordCount = 0
        let tags = []
        for (let memo of memos) {
          let date = DateUtil.formatDateStringToDateOnly(memo.created_at)
          if (memo.content) {
            wordCount += this.getMemoContentLength(memo)
          }
          tags = tags.concat(memo.tags)
          if (memoCountByDay[date]) {
            memoCountByDay[date]++
          } else {
            memoCountByDay[date] = 1
          }
        }

        // tag 去重
        tags = Array.from(new Set(tags))
        resolve({
          count,
          memoCountByDay,
          wordCount,
          tagCount: tags.length,
          memoCount: memos.length,
        })
      })
    })
  }

  // 按照月份获取 memo 数量
  static getMemoCountByMonth(date) {
    return new Promise((resolve) => {
      // 根据date获取当月的第一天和最后一天
      const firstDay = DateUtil.getFirstDayOfMonth(date)
      const lastDay = DateUtil.getLastDayOfMonth(date)

      const query = db.memos
        .where('created_at_long')
        .between(DateUtil.formatDateToLong(firstDay), DateUtil.formatDateToLong(lastDay))
        .toArray()

      query.then((memos) => {
        memos = memos.filter(function (item) {
          return !item.deleted_at
        })

        let count = memos.length
        let wordCount = 0
        let memoCountByDay = {}
        let wordCountByDay = {}
        for (let memo of memos) {
          let date = DateUtil.formatDateStringToDateOnly(memo.created_at)
          wordCount += this.getMemoContentLength(memo)

          if (memoCountByDay[date]) {
            memoCountByDay[date]++
          }
          if (wordCountByDay[date]) {
            wordCountByDay[date] += this.getMemoContentLength(memo)
          }

          if (!memoCountByDay[date]) {
            memoCountByDay[date] = 1
            wordCountByDay[date] = this.getMemoContentLength(memo)
          }
        }
        resolve({
          count: count,
          memoCountByDay: memoCountByDay,
          wordCount,
          wordCountByDay,
        })
      })
    })
  }

  // 查询所有的 memo
  static getAllMemos() {
    return new Promise((resolve) => {
      const query = db.memos.orderBy('created_at_long').toArray()
      query.then((memos) => {
        const newMemos = memos.filter(function (item) {
          return !item.deleted_at && item.content
        })

        // 计算一共有多少天有 memo
        let memoCountByDay = {}
        for (let memo of newMemos) {
          let date = DateUtil.formatDateStringToDateOnly(memo.created_at)
          if (memoCountByDay[date]) {
            memoCountByDay[date]++
          } else {
            memoCountByDay[date] = 1
          }
        }

        const memoCountByDayArray = Object.keys(memoCountByDay).map((key) => {
          return {
            date: key,
            count: memoCountByDay[key],
          }
        })

        // 字数分布 0-50 50-140 140-500 500-1000 1000+
        let wordCountByRange = {
          50: 0,
          100: 0,
          150: 0,
          200: 0,
          250: 0,
          300: 0,
          350: 0,
          400: 0,
          450: 0,
          500: 0,
          1000: 0,
          1100: 0,
        }
        for (let memo of newMemos) {
          let wordCount = this.getMemoContentLength(memo)
          if (wordCount <= 50) {
            wordCountByRange[50]++
          } else if (wordCount <= 100) {
            wordCountByRange[100]++
          } else if (wordCount <= 150) {
            wordCountByRange[150]++
          } else if (wordCount <= 200) {
            wordCountByRange[200]++
          } else if (wordCount <= 250) {
            wordCountByRange[250]++
          } else if (wordCount <= 300) {
            wordCountByRange[300]++
          } else if (wordCount <= 350) {
            wordCountByRange[350]++
          } else if (wordCount <= 400) {
            wordCountByRange[400]++
          } else if (wordCount <= 450) {
            wordCountByRange[450]++
          } else if (wordCount <= 500) {
            wordCountByRange[500]++
          } else if (wordCount <= 1000) {
            wordCountByRange[1000]++
          } else if (wordCount <= 1100) {
            wordCountByRange[1100]++
          }
        }

        // 时间分布，计算每条memo 周几写的 0-6 0是周日 6是周六 几点写的 0-6 6-12 12-18 18-24

        let memoCountByWeekAndHour = []
        let memoCount = {}
        newMemos.map((memo) => {
          let date = new Date(memo.created_at)
          let week = date.getDay()
          let hour = date.getHours()

          if (memoCount[hour + '-' + week]) {
            memoCount[hour + '-' + week]++
          } else {
            memoCount[hour + '-' + week] = 1
          }
          memoCountByWeekAndHour.push([hour, week])
        })

        memoCountByWeekAndHour.map((hourWeek) => {
          hourWeek[2] = memoCount[hourWeek[0] + '-' + hourWeek[1]]
        })

        let memoCountBySource = {
          app: 0,
          web: 0,
          wx: 0,
          api: 0,
          // other: 0,
        }

        for (let memo of newMemos) {
          if (memo.source === 'ios' || memo.source === 'android' || memo.source === 'mobile') {
            memoCountBySource.app++
          } else if (memo.source === 'web') {
            memoCountBySource.web++
          } else if (memo.source === 'wechat') {
            memoCountBySource.wx++
          } else if (memo.source === 'incoming_webhook') {
            memoCountBySource.api++
          }
        }

        let memoCountByType = {
          text: 0,
          image: 0,
          audio: 0,
          link: 0,
        }

        const textMemos = newMemos.filter(function (item) {
          return (!item.files || !item.files.length) && (!item.links || !item.links.length)
        })

        memoCountByType.text = textMemos.length

        const filesMemo = newMemos.filter(function (item) {
          return item.files && item.files.length
        })

        filesMemo.forEach((memo) => {
          memo.files.forEach((file) => {
            if (!file) {
              return
            }
            if (file.type && file.type.indexOf('image') > -1) {
              memoCountByType.image++
            }

            if (file.type && file.type.indexOf('audio') > -1) {
              memoCountByType.audio++
            }
          })
        })

        const linkMemos = newMemos.filter((memo) => {
          return memo.links && memo.links.length
        })

        memoCountByType.link = linkMemos.length

        resolve({
          wordCountByRange,
          memoCountByWeekAndHour,
          memoCountBySource,
          memoCountByType,
          memoCountByDayArray,
        })
      })
    })
  }

  // query all memos contain string
  //static queryMemosWithString(string) {
  //  return new Promise((resolve) => {
  //    const keywords = string.split(' ')
  //    const uniqueKeywords = Array.from(new Set(keywords))
  //    const query = db.memos.orderBy('created_at_long').toArray()
  //    query.then((memos) => {
  //      memos.sort(function (a, b) {
  //        return b.created_at_long - a.created_at_long
  //      })

  //      const newMemos = memos
  //        .filter(function (item) {
  //          return !item.deleted_at
  //        })
  //        .filter((memo) => {
  //          return memo.content
  //        })

  //      let result = []
  //      for (let memo of newMemos) {
  //        let content = memo.content
  //        let match = true
  //        for (let keyword of uniqueKeywords) {
  //          if (content.toLowerCase().indexOf(keyword.toLowerCase()) === -1) {
  //            match = false
  //            break
  //          }
  //        }
  //        if (match) {
  //          result.push(memo)
  //        }
  //      }
  //      result.forEach((memo) => {
  //        memo.content = memo.content.replace(/<p>/g, ' ').replace(/<\/p>/g, ' ')
  //        let content = memo.content.replace(/<[^>]+>/g, '')
  //        let index = content.toLowerCase().indexOf(string.toLowerCase())
  //        let start = index - 30 > 0 ? index - 30 : 0
  //        let end = content.length
  //        memo.content = content.substring(start, end)
  //        if (start !== 0) {
  //          memo.content = '...' + memo.content
  //        }
  //      })
  //      resolve({
  //        memos: result,
  //      })
  //    })
  //  })
  //}

  static async queryMemosWithString(string) {
    try {
      const memos = await db.memos.orderBy('created_at_long').toArray()

      memos.sort((a, b) => b.created_at_long - a.created_at_long)

      const newMemos = memos.filter((item) => !item.deleted_at).filter((memo) => memo.content)

      const keywords = string.split(' ')
      const result = []

      for (let memo of newMemos) {
        let content = memo.content
        let match = true

        for (let keyword of keywords) {
          if (content.toLowerCase().indexOf(keyword.toLowerCase()) === -1) {
            match = false
            break
          }
        }

        if (match) {
          result.push(memo)
        }
      }

      result.forEach((memo) => {
        memo.content = memo.content.replace(/<p>/g, ' ').replace(/<\/p>/g, ' ')
        let content = memo.content.replace(/<[^>]+>/g, '')
        let index = content.toLowerCase().indexOf(string.toLowerCase())
        let start = index - 30 > 0 ? index - 30 : 0
        let end = content.length
        memo.content = content.substring(start, end)
        if (start !== 0) {
          memo.content = '...' + memo.content
        }
      })

      return { memos: result }
    } catch (error) {
      throw error
    }
  }

  // 获取所有tag，并计算每个tag下的memo数量
  static getAllTags() {
    return new Promise((resolve) => {
      const query = db.memos.orderBy('created_at_long').toArray()
      query.then((memos) => {
        const newMemos = memos.filter(function (item) {
          return !item.deleted_at && item.tags
        })

        let tags = []
        let tagCount = {}
        newMemos.forEach((memo) => {
          memo.tags.forEach((tag) => {
            if (tags.indexOf(tag) === -1) {
              tags.push(tag)
            }
            if (tagCount[tag]) {
              tagCount[tag]++
            } else {
              tagCount[tag] = 1
            }
          })
        })

        let result = []
        tags.forEach((tag) => {
          result.push({
            name: tag,
            value: tagCount[tag],
          })
        })

        // 构造tag tree
        let tagTree = []
        result.forEach((tag) => {
          let tagArray = tag.name.split('/')
          let parent = tagTree
          let parentName = ''
          for (let i = 0; i < tagArray.length; i++) {
            let tagItem = tagArray[i]
            let tagItemName = parentName + tagItem
            let exist = false
            for (let j = 0; j < parent.length; j++) {
              if (parent[j].name === tagItem) {
                exist = true
                parent = parent[j].children
                break
              }
            }
            if (!exist) {
              let newTag = {
                name: tagItem,
                children: [],
                value: tagCount[tagItemName],
              }
              parent.push(newTag)
              parent = newTag.children
            }
            parentName = tagItemName + '/'
          }
        })

        resolve({
          tags: tagTree,
        })
      })
    })
  }

  // 获取所有的 memo，并按月份分组
  static getAllMemosByMonth() {
    return new Promise((resolve) => {
      const query = db.memos.orderBy('created_at_long').toArray()
      query.then((memos) => {
        memos.sort(function (a, b) {
          return b.created_at_long - a.created_at_long
        })

        const newMemos = memos.filter(function (item) {
          return !item.deleted_at
        })
        const memosGroupByMonth = newMemos.reduce((acc, cur) => {
          const month = cur.created_at.slice(0, 7)
          if (!acc[month]) {
            acc[month] = []
          }
          acc[month].push(cur)
          return acc
        }, {})

        resolve({
          memosGroupByMonth,
          total: newMemos.length,
        })
      })
    })
  }

  // 根据条件查询memo，并按月份分组
  static getMemosByMonth(
    tag,
    search,
    start_date,
    end_date,
    source,
    with_image,
    with_tag,
    with_link,
    contain_tag,
    last_year_today,
    deny_tag,
  ) {
    return new Promise((resolve) => {
      let query = db.memos
      if (start_date != null && end_date != null) {
        start_date = start_date + ' 00:00:00'
        end_date = end_date + ' 23:59:59'
        query = query.where('created_at').between(start_date, end_date)
      }
      if (last_year_today != null) {
        // 获取去年今天的日期
        let last_year_today_date = new Date()
        last_year_today_date.setFullYear(last_year_today_date.getFullYear() - 1)
        last_year_today_date = DateUtil.formatDateStringToDateOnly(last_year_today_date)
        let last_year_today_start = last_year_today_date + ' 00:00:00'
        let last_year_today_end = last_year_today_date + ' 23:59:59'
        query = query.where('created_at').between(last_year_today_start, last_year_today_end)
      }
      if (source != null) query = query.where('source').equals(source)

      query = query.filter(function (item) {
        let result_search = true
        let result_tag = true
        if (search != null) {
          let searchArr = []
          if (search.includes(' ')) {
            let arr = search.split(' ')
            for (let item of arr) {
              if (item != ' ' && item.length > 0) searchArr.push(item)
            }
          } else {
            searchArr.push(search)
          }
          if (item.content) {
            for (let keyword of searchArr) {
              // 过滤 content 中的 html 标签，只匹配纯文本
              let content = item.content.replace(/<[^>]+>/g, '')
              result_search = content.toLowerCase().includes(keyword.toLowerCase())
              if (!result_search) {
                result_search = false
                break
              }
            }
          } else result_search = false
        }
        if (tag) {
          result_tag = item.tags.includes(tag)
        }

        if (deny_tag) {
          result_tag = !item.tags || !item.tags.includes(deny_tag)
        }

        let result_image_filter = true
        if (typeof with_image == 'undefined') {
          result_image_filter = true
        } else if (with_image) {
          result_image_filter = item.files != null && item.files.length > 0
        } else {
          result_image_filter = item.files == null || item.files.length == 0
        }

        let result_tag_filter = true
        if (typeof with_tag == 'undefined') {
          result_tag_filter = true
        } else if (with_tag) {
          result_tag_filter = item.tags != null && item.tags.length > 0
        } else {
          result_tag_filter = item.tags == null || item.tags.length == 0
        }

        let result_link_filter = true
        if (typeof with_link == 'undefined') {
          result_link_filter = true
        } else if (with_link) {
          result_link_filter = item.links != null && item.links.length > 0
        } else {
          result_link_filter = item.links == null || item.links.length == 0
        }

        let result_contain_tag = true
        if (typeof contain_tag == 'undefined') {
          result_contain_tag = true
        } else if (contain_tag) {
          result_contain_tag = item.tags != null && item.tags.length > 0 && item.tags.includes(tag)
        } else {
          result_contain_tag = item.tags != null && item.tags.length > 0 && !item.tags.includes(tag)
        }
        return (
          result_search &&
          result_tag &&
          item.deleted_at_long == 0 &&
          result_image_filter &&
          result_tag_filter &&
          result_link_filter &&
          result_contain_tag
        )
      })
      query = query.reverse().sortBy('created_at_long')

      query.then(async (memos) => {
        memos.sort(function (a, b) {
          return b.created_at_long - a.created_at_long
        })
        const newMemos = memos.filter(function (item) {
          return !item.deleted_at
        })
        const memosGroupByMonth = newMemos.reduce((acc, cur) => {
          const month = cur.created_at.slice(0, 7)
          if (!acc[month]) {
            acc[month] = []
          }
          acc[month].push(cur)
          return acc
        }, {})

        resolve({
          memosGroupByMonth,
          total: newMemos.length,
        })
      })
    })
  }

  // 把 已经下载的 file blob 存入 db zipCache
  static saveZipCache(id, file, path) {
    return new Promise((resolve) => {
      db.zipCache.put({
        id,
        file,
        path,
      })
      resolve()
    })
  }

  // 查询 已经下载的 file blob
  static getZipCache() {
    return new Promise((resolve) => {
      const query = db.zipCache.toArray()
      query.then((zipCache) => {
        resolve({
          zipCache,
        })
      })
    })
  }

  // 删除 已经下载的 file blob
  static deleteZipCache() {
    return new Promise((resolve) => {
      db.zipCache.clear()
      resolve()
    })
  }

  // 获取 memo content length
  static getMemoContentLength(memo) {
    if (memo.content) {
      return memo.content.replace(/<[^>]+>/g, '').length
    } else {
      return 0
    }
  }

  // 通过更新memo来更新memo的pin
  static updateMemoPinByMemo(memo) {
    return new Promise(async (resolve) => {
      let count = await db.memos.where('pin').notEqual(0).count()

      if (count == 1) {
        resolve(false)
        return
      }

      let find = await db.memos.get({ slug: memo.slug })
      find.pin = 1
      const res = await this.editMemo(find)
      resolve(res)
    })
  }

  // unPin memo
  static unPinMemo(memo) {
    return new Promise(async (resolve) => {
      let find = await db.memos.get({ slug: memo.slug })
      find.pin = 0
      const newMemo = {
        ...memo,
        pin: 0,
      }

      const res = await this.editMemo(newMemo)

      resolve(res)
    })
  }

  //select daily review list
  static async getDailyReviewList(type, tags, timeRange) {}

  static async getSlugList(slugs) {
    return new Promise(async (resolve) => {
      let res = await db.memos.where('slug').anyOf(slugs).toArray()
      // 按照 slugs 顺序排序
      let sortedRes = []
      for (let slug of slugs) {
        for (let item of res) {
          if (item.slug == slug) {
            sortedRes.push(item)
            break
          }
        }
      }

      let waitForCheck = []
      for (let item of sortedRes) {
        await DBUtil.prepareMemoLinks(item)
        await DBUtil.applyTags(item)
        await DBUtil.prepareFiles(item)
        await DBUtil.isShowCloud(item)
        DBUtil.reformatDate(item)
        if (item.files) waitForCheck = waitForCheck.concat(item.files)
      }
      let refreshFiles = await DBUtil.checkImageUrl(waitForCheck)
      let memosNeedRefresh = []
      if (refreshFiles && refreshFiles.length > 0) {
        for (let item of sortedRes) {
          if (item.files) {
            for (let i = 0; i < item.files.length; i++) {
              let file = item.files[i]
              let needRefresh = false
              for (let refreshFile of refreshFiles) {
                if (refreshFile.id == file.id) {
                  item.files.splice(i, 1, refreshFile)
                  needRefresh = true
                }
              }
              if (needRefresh) memosNeedRefresh.push(item)
            }
          }
        }
      }
      resolve(sortedRes)
      //更新到数据库
      if (refreshFiles && refreshFiles.length > 0) {
        //更新file表
        db.files.bulkPut(refreshFiles)
        db.memos.bulkPut(memosNeedRefresh)
      }
    })
  }

  /**
   * memo 更新后，更新关联的 memo
   * @param {*} linked_memos
   * @returns
   */

  static async handle_linked_memos(linked_memos) {
    if (linked_memos.length === 0 || !linked_memos) return
    const memos = await db.memos
      .where('slug')
      .anyOf(linked_memos.map((memo) => memo.slug))
      .toArray()

    memos.forEach(async (memo) => {
      await DBUtil.prepareMemoLinks(memo)
      await DBUtil.applyTags(memo)
      await DBUtil.prepareFiles(memo)
      await DBUtil.isShowCloud(memo)
      DBUtil.reformatDate(memo)

      emitter.emit('memo-updated', memo)
    })
  }

  static async getNewReviewList(slugs) {
    return new Promise(async (resolve) => {
      const res = await db.memos.where('slug').anyOf(slugs).toArray()

      // 按照 slugs 顺序排序
      let sortedRes = []
      for (let slug of slugs) {
        for (let item of res) {
          if (item.slug == slug && !item.deleted_at) {
            sortedRes.push(item.slug)
            break
          }
        }
      }
      resolve(sortedRes)
    })
  }

  // 获取最新的 10 条 memo
  static async getNewMemoList() {
    let startTime = Date.now().valueOf()
    return new Promise((resolve) => {
      let query = db.memos.where('deleted_at_long').equals(0).limit(10).reverse().sortBy('created_at_long')
      query.then(async (memos) => {
        memos = memos.slice(0, 10)
        let endTime = Date.now().valueOf()
        console.log('getNewMemoList 耗时', endTime - startTime + 'ms')
        let waitForCheck = []

        for (let item of memos) {
          await DBUtil.prepareMemoLinks(item)
          await DBUtil.applyTags(item)
          await DBUtil.prepareFiles(item)
          await DBUtil.isShowCloud(item)
          DBUtil.reformatDate(item)

          if (item.files) waitForCheck = waitForCheck.concat(item.files)
        }

        let refreshFiles = await DBUtil.checkImageUrl(waitForCheck)
        let memosNeedRefresh = []
        if (refreshFiles && refreshFiles.length > 0) {
          for (let item of memos) {
            if (item.files) {
              for (let i = 0; i < item.files.length; i++) {
                let file = item.files[i]
                let needRefresh = false
                for (let refreshFile of refreshFiles) {
                  if (refreshFile.id == file.id) {
                    item.files.splice(i, 1, refreshFile)
                    needRefresh = true
                  }
                }
                if (needRefresh) memosNeedRefresh.push(item)
              }
            }
          }
        }

        resolve({
          total: memos.length,
          memos,
        })

        //更新到数据库
        if (refreshFiles && refreshFiles.length > 0) {
          //更新file表
          db.files.bulkPut(refreshFiles)
          db.memos.bulkPut(memosNeedRefresh)
        }
      })
    })
  }

  // 判断是否同步成功
  static async checkMemoSyncComplete() {
    if (!DBUtil.newMemos.length) return

    DBUtil.newMemos.forEach((memo) => {
      //  未同步
      if (memo.slug.indexOf('local') > -1) {
        memo.is_show_cloud = true
        emitter.emit('memo-updated', memo)
      } else {
        // 已经同步
        DBUtil.newMemos = DBUtil.newMemos.filter((m) => m.fake_slug != memo.fake_slug)
      }
    })
  }

  // console.log 屏蔽 content
  static log(log) {
    const sanitizedLog = { ...log }
    if (log.data && log.data.content) {
      sanitizedLog.data = { ...log.data, content: '******' }
    } else if (log.content) {
      sanitizedLog.content = '******'
    }
    console.log(sanitizedLog)
  }
}
